//#region Imports
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
//MUI
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import PrintIcon from '@mui/icons-material/Print';
import { Box, Button, FormControl, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
//components
import Base64Image from '../../../components/Base64Image/Base64Image';
import StepProgressBar from '../../../components/StepProgressBar/StepProgressBar';
import ProcessingSummaryTable from '../../../components/processingSummaryTable/processingSummaryTable';

//scss
import "../../../style/common.scss";
//react-toastify
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//Yup
import * as Yup from "yup";
//formik
import { useFormik } from 'formik';
//urls
import { cfpBaseUrl } from '../../../network/urls';
// use scan detection
//Check Permissions
import CheckPermissions from '../../../authorization/authorization';
//Services
import JsBarcode from 'jsbarcode';
import { jsPDF } from "jspdf";
import 'jspdf-autotable';
import { GlobalWorkerOptions, getDocument } from 'pdfjs-dist';
import BasicTable from '../../../components/basicTable/basicTable';
import mepcologo from '../../../images/mepcoLogo.png';
import pdfIcon from '../../../images/pdfIcon.png';
import MEPCOWaterMark from '../../../images/DiscosWater/mepcco-watermark.png';
import LESCOWaterMark from '../../../images/DiscosWater/lescowatermark.png';
import IESCOWaterMark from '../../../images/DiscosWater/iescowatermark.png';
import FESCOWaterMark from '../../../images/DiscosWater/fesco-watermark.png';
import GEPCOWaterMark from '../../../images/DiscosWater/gepco-watermark.png';
import HAZECOWaterMark from '../../../images/DiscosWater/hazeco-watermark.png';
import HESCOWaterMark from '../../../images/DiscosWater/hesco-watermark.png';
import TESCOWaterMark from '../../../images/DiscosWater/tesco-watermark.png';
import SEPCOWaterMark from '../../../images/DiscosWater/sepco-watermark.png';
import PESCOWaterMark from '../../../images/DiscosWater/pesco-watermark.png';
import QESCOWaterMark from '../../../images/DiscosWater/qesco-watermark.png';
import { dBillAPI, getDocumentBackGroundColor, isFileNameImage, isFileNamePdf } from '../../../services/Functions';
import OpenBase64ImageInPopup from '../../../services/OpenBase64ImageInPopup';
import { tableStyle } from '../../../style/common';
import { documentExtensions } from '../../../utils/PortalName';


//#endregion

const OptForSmartMeterTable = () => {

    //#region initial values
    const initialValues = {
        iv_objection_Type: '',
        iv_objection_Descripton: '',
        iv_consent_submitted: 1,
        iv_consent_image: '',
        iv_property_reference_no: '',
        iv_coverage_area: '',
        iv_tariff_to_allot: '',
        iv_reference_to_allot: '',
        iv_industry_factory_type: '',
        iv_bank_name: '',
        iv_connection_account_no: ''
    }


    //#endregion

    //#region get item local storage 
    const token = JSON.parse(window.localStorage.getItem('user-token'));
    const userRole = JSON.parse(window.localStorage.getItem('user-role'));
    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
    const officeCode = parseInt(JSON.parse(window.localStorage.getItem('user-office-code')))
    const officeHierarchy = parseInt(JSON.parse(window.localStorage.getItem('user-hierarchy')))
    const userName = JSON.parse(window.localStorage.getItem('user-name'));
 let userCompany = officeCode.slice(0, 2);
  const getWaterMarkLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOWaterMark
      case '12':
        return GEPCOWaterMark
      case '13':
        return FESCOWaterMark
      case '14':
        return IESCOWaterMark
      case '15':
        return MEPCOWaterMark
      case '26':
        return PESCOWaterMark
      case '27':
        return HAZECOWaterMark
      case '37':
        return HESCOWaterMark
      case '38':
        return SEPCOWaterMark
      case '48':
        return QESCOWaterMark
      case '59':
        return TESCOWaterMark
      default:
        return MEPCOWaterMark
    }
  }

    //#endregion

    //#region states 
    const [objectionType, setObjectionType] = React.useState('');
    const [allTariffList, setAllTariffList] = useState([]);
    const [tariffList, setTariffList] = useState([]);
    const [tariffToAllot, setTariffToAllot] = React.useState('');
    const [referenceNumberToAllot, setReferenceNumberToAllot] = useState('');
    const [sketchDiagram, setSketchDiagram] = React.useState('');
    const [consentImage, setConsentImage] = useState('');
    const [consentImageThumbnail, setConsentImageThumbnail] = useState(null);
    const [arrearsDetails, setArrearsDetails] = useState({
        arrearsAmount: null,
        meterStatus: '',
        tariffDesc: '',
        meterType: '',
        phase: '',
        consumerName: '',
        consumerNo: "",
        consumerAddress: '',
        consumerEmail: '',
    });
    const [partialValue, setPartialValue] = useState('');
    const [noArrears, setNoArrears] = useState('');
    const [flag_copyOfApplicantCNIC, setFlag_copyOfApplicantCNIC] = useState(null)
    const [flag_applicantLastPaidBill, setFlag_applicantLastPaidBill] = useState(null)
    const [propertyDocVerifyPopUp, setPropertyDocVerifyPopUp] = useState(false);

    //const [newConnectionApplications, setNewConnectionApplications] = useState([]);
    const [optApplications, setOptApplications] = useState([]);
    // const [newConnectionApplicationsToDataGrid, setNewConnectionApplicationsToDataGrid] = useState([]);
    const [optApplicationsToDataGrid, setOptApplicationsToDataGrid] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [objectionPopUpOpen, setObjectionPopUpOpen] = React.useState(false);
    const [arrearsEntryPopUpOpen, setArrearsEntryPopUpOpen] = React.useState(false);
    const [arrearsVerifyPopUpOpen, setArrearsVerifyPopUpOpen] = React.useState(false);
    const [docVerifyAlert, setDocVerifyAlert] = React.useState(false);
    const [fieldVerifyAlert, setFieldVerifyAlert] = React.useState(false);
    const [dnPaymentVerifyAlert, setDnPaymentVerifyAlert] = React.useState(false);
    const [rejectionRemovalAlert, setRejectionRemovalAlert] = React.useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [copyOfApplicantCNICVerifyPopUp, setCopyOfApplicantCNICVerifyPopUp] = useState(false);
    const [flag_premisesDocument, setFlag_premisesDocument] = useState(null)
    const [flag_copyOfApplicantCNICFront, setFlag_copyOfApplicantCNICFront] = useState(null)
    const [flag_copyOfApplicantCNICBack, setFlag_copyOfApplicantCNICBack] = useState(null)
    const [showConsentForm, setShowConsentForm] = useState(false);
    const [consentDetails, setConsentDetails] = useState({
        applicationId: '',
        isConsumerConsentSigned: '',
        signedConsumerConsentImage: '',
        consumerConsentFilledBy: '',
        consumerConsentFilledDate: '',
        consumerConsentFillFlag: null,
        consumerConsentApproveBy: '',
        consumerConsentApproveDate: '',
        consumerConsentApproveFlag: null
    })
    const [newConnectionApplications, setNewConnectionApplications] = useState([]);

    const [eFileData, setEFileData] = useState([]);
    const [removedMeterImageThumbnail, setRemovedMeterImageThumbnail] = useState('')
    const [installedMeterImageThumbnail, setInstalledMeterImageThumbnail] = useState('')

    const [documentsVerifiedSubPopUp, setDocumentsVerifiedSubPopUp] = useState(false);
    const [arrearVerifiedSubPopUp, setArrearVerifiedSubPopUp] = useState(false);
    const [fieldSurveyedSubPopUp, setFieldSurveyedSubPopUp] = useState(false);
    const [referenceNoAllocatedSubPopUp, setReferenceNoAllocatedSubPopUp] = useState(false);
    const [dnPaymentSubmittedSubPopUp, setDnPaymentSubmittedSubPopUp] = useState(false);
    const [dnPaymentVerifiedSubPopUp, setDnPaymentVerifiedSubPopUp] = useState(false);
    const [serviceConnectionOrderedSubPopUp, setServiceConnectionOrderedSubPopUp] = useState(false);
    const [meterInstalledSubPopUp, setMeterInstalledSubPopUp] = useState(false);
    const { state } = useLocation();
    const { foundId } = state ? state : '';
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [mcoDetails, setMcoDetails] = useState({
        mcoId: "",
        applicationId: "",
        mcoCreationDate: "",
        meterType: null,
        refNo: null,
        batchNo: null,
        consumerName: null,
        address: null,
        MEMoNo: null,
        MEMODate: null,
        reason: null,
        mtNo: null,
        mtDate: null,
        mcoP1FilledBy: null,
        mcoP1FilledDate: null,
        mcoP1FilledFlag: null,
        mcoOrderByName: null,
        mcoOrderedDate: null,
        mcoOrderFlag: null,
        removedMeterNo: null,
        removedMnfgCode: null,
        removedMeterMF: null,
        removedMeterRange: null,
        removedMeterKWHPeak: null,
        removedMeterKWHOffPeak: null,
        removedMeterKVARHPeak: null,
        removedMeterKVARHOffPeak: null,
        removedMeterMDISUMPeak: null,
        removedMeterMDISUMOffPeak: null,
        removedMeterImage: null,
        resetNo: null,
        installedMeterNo: null,
        installedMnfgCode: null,
        installedMeterMF: null,
        installedMeterRange: null,
        installedMeterKWHPeak: null,
        installedMeterKWHOffPeak: null,
        installedMeterKVARHPeak: null,
        installedMeterKVARHOffPeak: null,
        installedMeterMDISUMPeak: null,
        installedMeterMDISUMOffPeak: null,
        installedMeterResetNo: null,
        installedMeterImage: null,
        checkingReportNo: null,
        checkingReportDate: null,
        storeRequisitionNo: null,
        storeRequisitionDate: null,
        cpForm78: null,
        cpForm79: null,
        ca21: null,
        ca22: null,
        meterChangedBy: null,
        meterChangedDesignation: null,
        meterChangedDate: null,
        complianceBy: null,
        complianceDate: null,
        complianceFlag: null,
        mcoP2approvedBy: null,
        mcoP2approvedDate: null,
        mcoP2approvedFlag: null
    });
    const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState([
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        }])
    const tableColumnsProcessingSummary = [
        {
            header: 'Step',
            accessorKey: 'stepName',
        },
        {
            header: 'Processed By',
            accessorKey: 'processedBy',
        },
        {
            header: 'Date',
            accessorKey: 'date',
        },
        {
            header: 'Time',
            accessorKey: 'time',
        },
        {
            header: 'Remarks',
            accessorKey: 'remarks',
        },
    ]

    const [consentImagePopUp, setConsentImagePopUp] = useState(false)
    const [removedMeterImage, setRemovedMeterImage] = useState('')
    const [removedMeterImageFileName, setRemovedMeterImageFileName] = useState('')
    const [installedMeterImage, setInstalledMeterImage] = useState('')
    const [installedMeterImageFileName, setInstalledMeterImageFileName] = useState('')


    //#endregion

    //#region constants / variables 
    const navigate = useNavigate();

    const fieldObjections = [
        "Unelectrified area / No Lt network.",
        "Meters already installed at applied premisies.",
        "Invalid address.",
        "Premises / Property is disputed or sub judice.",
        "Load at site exceeds than applied.",
        "No load / building at site.",
        "Transformer overloaded"
    ]

    var remarksToSave = "";

    const tenantStatus = ['tenant', 'Tenant']

    //#endregion

    //#region api function


    const referenceApi = async () => {
        if (!arearsFormik.values.iv_property_reference_no || arearsFormik.values.iv_property_reference_no.length !== 14) {
            // console.log(' Not running')
            return;
        }

        // console.log("inreference fuunction")
        var requestOptions = {
            method: 'GET',
            redirect: 'follow',
        };

        let apiResponse = await dBillAPI(token, arearsFormik.values.iv_property_reference_no)
        if (apiResponse.status) {
            let basicInfo = apiResponse.basicInfo;
            if (basicInfo.arrear == "") {
                let arrearDetailsObj = {}
                arrearDetailsObj.arrearsAmount = ''
                arrearDetailsObj.meterStatus = ''
                arrearDetailsObj.tariffDesc = ''
                arrearDetailsObj.meterType = ''
                arrearDetailsObj.phase = ''
                arrearDetailsObj.consumerName = ''
                arrearDetailsObj.consumerNo = ''
                arrearDetailsObj.consumerAddress = ''
                arrearDetailsObj.consumerEmail = ''
                setArrearsDetails(arrearDetailsObj);
                setNoArrears('No arrears exist for entered reference number.');
            }
            else if (basicInfo.arrear != '') {
                let arrearDetailsObj = {}
                setNoArrears('');
                arrearDetailsObj.arrearsAmount = numberFormatting(basicInfo.arrear)
                arrearDetailsObj.meterStatus = basicInfo.meter1Status
                arrearDetailsObj.tariffDesc = basicInfo.tariffDescription
                arrearDetailsObj.meterType = basicInfo.meterType
                arrearDetailsObj.phase = basicInfo.phase
                arrearDetailsObj.consumerName = basicInfo.consumerName
                arrearDetailsObj.consumerNo = basicInfo.consumerContactNo
                arrearDetailsObj.consumerAddress = basicInfo.consumerAddress1 + ' ' + basicInfo.consumerAddress2
                arrearDetailsObj.consumerEmail = basicInfo.consumerEmail
                setArrearsDetails(arrearDetailsObj);
            }
        } else {
            console.log('Reference No. not exist!')
        }
    };

    const callingUpdateDocumentStatusAPI = async () => {
        var formdata = new FormData();
        formdata.append("applicationId", dialogRowData.applicationId);
        // console.log(flag_copyOfApplicantCNIC, "copyOfApplicantCNICFlag");
        // console.log(flag_applicantLastPaidBill, "applicantLastPaidBillFlag")
        formdata.append("copyOfApplicantCNICFlag", flag_copyOfApplicantCNIC);
        formdata.append("applicantLastPaidBillFlag", flag_applicantLastPaidBill);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;
        // console.log(token, "token")
        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "optForSmartMeter/updateCNICFlag", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    //toast.success(result.message)
                    if (
                        flag_copyOfApplicantCNIC === -1 ||
                        flag_applicantLastPaidBill === -1
                    ) {

                        if (flag_copyOfApplicantCNIC === -1) {
                            remarksToSave.concat("Applicant CNIC, ")
                        }
                        if (flag_applicantLastPaidBill === -1) {
                            remarksToSave.concat("Last Bill Document, ")
                        }
                        callObjectionRemarksAPI(remarksToSave);
                        let lclStrdOptApp = JSON.parse(window.localStorage.getItem('opt-for-smart-meter-applications'));
                        const index = lclStrdOptApp.findIndex(item => item.applicationId === dialogRowData.applicationId);
                        // console.log(flag_copyOfApplicantCNIC, 'Applicant CNIC Flag')
                        // console.log(flag_applicantLastPaidBill, 'Last Paid Bill Flag')
                        lclStrdOptApp[index].copyOfApplicantCNICFlag = flag_copyOfApplicantCNIC
                        lclStrdOptApp[index].applicantLastPaidBillFlag = flag_applicantLastPaidBill
                        window.localStorage.setItem('opt-for-smart-meter-applications', JSON.stringify(lclStrdOptApp));
                        setOptApplications(JSON.parse(window.localStorage.getItem('opt-for-smart-meter-applications')));
                        setFlag_copyOfApplicantCNIC(null)
                        setFlag_applicantLastPaidBill(null)
                    }
                    else {
                        updateProgressIdToDocumentsVerified()
                    }
                }
                else {
                    // console.log(result.message)
                }
            })
            .catch(error => console.log('error', error));
    }





    const callObjectionRemarksAPI = async (remarks) => {
        callChangeObjectionStatus(1)
        var formdata = new FormData();
        formdata.append("applicationId", dialogRowData.applicationId);
        formdata.append("remarks", "Documents are invalid. ".concat(remarks));
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "electricityNewConnection/objectionRemarks", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    // console.log('Status Updated')
                    let lclStrdOptApp = JSON.parse(window.localStorage.getItem('opt-for-smart-meter-applications'));
                    const index = lclStrdOptApp.findIndex(item => item.applicationId === dialogRowData.applicationId);
                    lclStrdOptApp[index].objectionStatus = 1
                    lclStrdOptApp[index].remarks = remarks
                    window.localStorage.setItem('opt-for-smart-meter-applications', JSON.stringify(lclStrdOptApp));
                    //setNewConnectionApplications(JSON.parse(window.localStorage.getItem('new-connection-applications')));
                    // toast.success("Objection Saved for application: " + dialogRowData.applicationId + ".")
                    setOpen(false);
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error => console.log('error', error));
    }

    const callChangeProgressIdAPI = async (applicationProgressId, status, remarks, remarksDetails = '-', id = dialogRowData.applicationId) => {
        var formdata = new FormData();
        formdata.append("applicationId", id);
        formdata.append("applicationProgressId", applicationProgressId);
        formdata.append("remarks", remarks);
        formdata.append("remarksDetails", remarksDetails);
        formdata.append("lastModifiedBy", userName);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "comman/changeProgressId", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let lclStrdOptApp = JSON.parse(window.localStorage.getItem('opt-for-smart-meter-applications'));
                    const index = lclStrdOptApp.findIndex(item => item.applicationId === id);
                    lclStrdOptApp[index].applicationProgressId = applicationProgressId
                    window.localStorage.setItem('opt-for-smart-meter-applications', JSON.stringify(lclStrdOptApp));
                    setOptApplications(JSON.parse(window.localStorage.getItem('opt-for-smart-meter-applications')));
                    // toast.success("Status of application: " + result.applicationId + " has be set to '" + status + "'.")
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error => console.log('error', error));

        setDocVerifyAlert(false);
        setFieldVerifyAlert(false);
        setOpen(false);
    }

    const callChangeObjectionStatus = async (step, objectionStatus, remarks, remarksDetails = '-') => {
        const token = JSON.parse(window.localStorage.getItem('user-token'));
        var formdata = new FormData();
        formdata.append("applicationId", dialogRowData.applicationId);
        formdata.append("objectionStatus", objectionStatus);
        formdata.append("remarks", remarks);
        formdata.append("remarksDetails", remarksDetails);
        formdata.append("lastModifiedBy", userName);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "comman/changeObjectionStatus", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let lclStrdOptApp = JSON.parse(window.localStorage.getItem('opt-for-smart-meter-applications'));
                    const index = lclStrdOptApp.findIndex(item => item.applicationId === dialogRowData.applicationId);
                    lclStrdOptApp[index].objectionStatus = objectionStatus
                    lclStrdOptApp[index].remarks = remarks
                    window.localStorage.setItem('opt-for-smart-meter-applications', JSON.stringify(lclStrdOptApp));
                    setOptApplications(JSON.parse(window.localStorage.getItem('opt-for-smart-meter-applications')));
                    setOpen(false);
                    if (step === "Document Verification" && objectionStatus === 1) {
                        // toast.success("Documents Objection saved for application: " + dialogRowData.applicationId + ".")
                    }
                    else if (step === "Document Verification" && objectionStatus === 2) {
                        // toast.success("Documents Objection removed for application: " + dialogRowData.applicationId + ".")
                    }
                    else if (step === "Arrears Verification" && objectionStatus === 1) {
                        // toast.success("Arrears Objection saved for application: " + dialogRowData.applicationId + ".")
                    }
                    else if (step === "Arrears Verification" && objectionStatus === 2) {
                        // toast.success("Arrears Objection removed for application: " + dialogRowData.applicationId + ".")
                    }
                    else if (step === "Field Survey" && objectionStatus === 1) {
                        // toast.success("Field survey objection saved for application: " + dialogRowData.applicationId + ".")
                    }
                    else if (step === "Field Survey" && objectionStatus === 2) {
                        // toast.success("Field survey objection removed for application: " + dialogRowData.applicationId + ".")
                    }
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error => console.log('error', error));

        setDocVerifyAlert(false);
        setRejectionRemovalAlert(false);
        setObjectionPopUpOpen(false);
        // setFieldRejectionRemovalAlert(false);
    }

    const callAsyncConsentDetailsAPI = async (applicationId) => {
        try {

            let consentDets = {}

            var formdata = new FormData();
            formdata.append("applicationId", applicationId);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "optForSmartMeter/getConsumerConsent", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        consentDets = result.data[0]
                    }
                }).catch(error => console.log('error', error));
            if (consentDets) {
                console.log(consentDets, 'olll')
                setConsentDetails(consentDets)
            }
            return consentDetails
        }
        catch (e) {
            console.log(e, 'Unable to get Consent Data.')
        }
    }

    const callConsentApprovalAPI = async (applicationId) => {
        try {
            let consentDets = {}

            var formdata = new FormData();
            formdata.append("applicationId", applicationId);
            formdata.append("consumerConsentApproveBy", userName);
            formdata.append("consumerConsentApproveFlag", 1);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            fetch(cfpBaseUrl + "optForSmartMeter/consumerConsentApproval", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        callChangeProgressIdAPI(5, 'Owner Consent Verification', 'Owner Consent Verification')

                    }
                })
                .catch(error => console.log('error', error));
        }
        catch (e) {
            console.log(e, 'Unable to approve Consent Data.')
        }
    }

    const callMCOCreationAPI = async (applicationId) => {
        if (applicationId) {
            var formdata = new FormData();
            formdata.append("applicationId", applicationId);
            formdata.append("paidDNImageVerifiedBy", userName)
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "mco/mcoCreation", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        // toast.success(result.message)
                        // callChangeProgressIdAPI(6, "DN Payment Verified", "DN Payment Verified")
                    }
                    else {
                        console.log(result.message)
                    }
                })
                .catch(error => {
                    console.log(error)
                });
        }
    }

    const callGetMCOAPI = async (applicationId) => {
        try {
            let mcoDets = ''
            if (applicationId) {
                var formdata = new FormData();
                formdata.append("applicationId", applicationId);
                formdata.append("scoId", "");
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);;

                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow',
                };

                await fetch(cfpBaseUrl + "mco/mcoDetails", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            mcoDets = result.data[0]
                            setMcoDetails(
                                result.data[0]
                            )
                            if (result.data[0].mcoP1FilledFlag === 1) {
                                mcoPart1Formik.values.iv_batch = mcoDets.batchNo
                                mcoPart1Formik.values.iv_memo_number = mcoDets.MEMoNo
                                mcoPart1Formik.values.iv_memo_date = mcoDets.MEMODate
                                mcoPart1Formik.values.iv_mt_number = mcoDets.mtNo
                                mcoPart1Formik.values.iv_mt_date = mcoDets.mtDate
                            }
                            if (result.data[0].complianceFlag === 1) {
                                mcoPart2Formik.values.iv_removed_Meter_No = mcoDets.removedMeterNo
                                mcoPart2Formik.values.iv_removed_Mnfg_Code = mcoDets.removedMnfgCode
                                mcoPart2Formik.values.iv_removed_Meter_MF = parseInt(mcoDets.removedMeterMF)
                                mcoPart2Formik.values.iv_removed_Meter_Range = mcoDets.removedMeterRange
                                mcoPart2Formik.values.iv_removed_Meter_KWH_Peak = parseInt(mcoDets.removedMeterKWHPeak)
                                mcoPart2Formik.values.iv_removed_Meter_KWH_OffPeak = parseInt(mcoDets.removedMeterKWHOffPeak)
                                mcoPart2Formik.values.iv_removed_Meter_KVARH_Peak = parseInt(mcoDets.removedMeterKVARHPeak)
                                mcoPart2Formik.values.iv_removed_Meter_KVARH_OffPeak = parseInt(mcoDets.removedMeterKVARHOffPeak)
                                mcoPart2Formik.values.iv_removed_Meter_MDI_SUMPeak = parseInt(mcoDets.removedMeterMDISUMPeak)
                                mcoPart2Formik.values.iv_removed_Meter_MDI_SUMOffPeak = parseInt(mcoDets.removedMeterMDISUMOffPeak)
                                mcoPart2Formik.values.iv_removed_Meter_Image = mcoDets.removedMeterImage
                                setRemovedMeterImageThumbnail(mcoDets.removedMeterImage)
                                mcoPart2Formik.values.iv_reset_No = mcoDets.resetNo
                                mcoPart2Formik.values.iv_installed_Meter_No = mcoDets.installedMeterNo
                                mcoPart2Formik.values.iv_installed_Meter_Mnfg_Code = mcoDets.installedMnfgCode
                                mcoPart2Formik.values.iv_installed_Meter_MF = parseInt(mcoDets.installedMeterMF)
                                mcoPart2Formik.values.iv_installed_Meter_Range = mcoDets.installedMeterRange
                                mcoPart2Formik.values.iv_installed_Meter_KWH_Peak = parseInt(mcoDets.installedMeterKWHPeak)
                                mcoPart2Formik.values.iv_installed_Meter_KWH_OffPeak = parseInt(mcoDets.installedMeterKWHOffPeak)
                                mcoPart2Formik.values.iv_installed_Meter_KVARH_Peak = parseInt(mcoDets.installedMeterKVARHPeak)
                                mcoPart2Formik.values.iv_installed_Meter_KVARH_OffPeak = parseInt(mcoDets.installedMeterKVARHOffPeak)
                                mcoPart2Formik.values.iv_installed_Meter_MDI_SUM_Peak = parseInt(mcoDets.installedMeterMDISUMPeak)
                                mcoPart2Formik.values.iv_installed_Meter_MDI_SUM_OffPeak = parseInt(mcoDets.installedMeterMDISUMOffPeak)
                                mcoPart2Formik.values.iv_installed_Meter_Reset_No = mcoDets.installedMeterResetNo
                                mcoPart2Formik.values.iv_installed_Meter_Image = mcoDets.installedMeterImage
                                setInstalledMeterImageThumbnail(mcoDets.installedMeterImage)
                                mcoPart2Formik.values.iv_checking_Report_No = mcoDets.checkingReportNo ? parseInt(mcoDets.checkingReportNo) : 0;
                                mcoPart2Formik.values.iv_checking_Report_Date = mcoDets.checkingReportDate
                                mcoPart2Formik.values.iv_store_requisition_no = mcoDets.storeRequisitionNo
                                mcoPart2Formik.values.iv_store_requisition_date = mcoDets.storeRequisitionDate
                                mcoPart2Formik.values.iv_cp_Form_78 = mcoDets.cpForm78
                                mcoPart2Formik.values.iv_cp_Form_79 = mcoDets.cpForm79
                                mcoPart2Formik.values.iv_ca21 = mcoDets.ca21
                                mcoPart2Formik.values.iv_ca22 = mcoDets.ca22
                                mcoPart2Formik.values.iv_meter_Changed_By = mcoDets.meterChangedBy
                                mcoPart2Formik.values.iv_meter_Changed_Designation = mcoDets.meterChangedDesignation
                                mcoPart2Formik.values.iv_meter_Changed_Date = mcoDets.meterChangedDate
                            }
                        }
                        else {
                            // toast.success("NO MCO")
                        }
                    })
                    .catch(error => console.log('error', error));
            }
            console.log(mcoDets, 'mco dets')
            return mcoDets
        }
        catch (e) {
            console.log(e, 'Unable to get SCO Details');
        }
    }

    //#endregion

    //#region functions
    const updateDocFlag = (documentName, value) => {
        switch (documentName) {
            case 'copyOfApplicantCNIC':
                setFlag_copyOfApplicantCNIC(value);
                setCopyOfApplicantCNICVerifyPopUp(false);
                break;
            case 'applicantLastPaidBill':
                setFlag_applicantLastPaidBill(value);
                setPropertyDocVerifyPopUp(false);
                break
            default:
                break

        }
    }

    const subdivisionName = (code) => {
        // console.log(code, 'subdivision code')
        if (code) {
            let subdivisionName = '';
            if (code !== 99999) {
                subdivisionName = subDivisions.find(item => item.subDivisionCode === code).subDivisionName
            }
            else {
                subdivisionName = code
            }
            return subdivisionName
        }
    }

    const applicationName = (code) => {
        if (code) {
            switch (code) {
                case 1:
                    return "New Connection"
                case 2:
                    return "Change of Load"
                case 3:
                    return "Change of Name"
                case 4:
                    return "Change of Tariff"
                default:
                    return "Application Type"
            }
        }
    }

    const hideConsentImagePopUp = () => {
        setConsentImagePopUp(false);
    }

    const ConsentImage = (event) => {
        fieldFormik.handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            console.log(extension, 'Printing Extension');
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "consemtImage." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setConsentImage(renamedFile);
                const reader = new FileReader();

                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setConsentImageThumbnail(e.target.result);
                };

                reader.readAsDataURL(file);
            } else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const documentValidation = (file, maxSize) => {
        console.log(file);
        let fileExtension = file.name.split(".").pop();

        if (["jpg", "png", "pdf", "JPG", "PNG", "jpeg", "JPEG", "PDF"].includes(fileExtension.toLowerCase())) {
            if (file.size <= maxSize) {
                return 1
            } else {
                return 2
            }
        } else {
            return 3
        }
    }

    const ObjectionType = (event) => {
        formik.handleChange(event);
        setObjectionType(event.target.value)
    };

    const TariffToAllot = (event) => {
        fieldFormik.handleChange(event);
        setTariffToAllot(event.target.value)
    };

    const handleClose = () => {
        fieldFormik.values.iv_consent_submitted = 1
        fieldFormik.values.iv_consent_image = ''

        setNoArrears('')
        setOpen(false);
    };

    const showObjectionPopup = () => {
        setObjectionPopUpOpen(true);
    }

    const showArrearsEntryPopup = () => {

        if (dialogRowData.applicationProgressId === 2) {
            arearsFormik.values.iv_property_reference_no = dialogRowData.refNo
        }
        setArrearsEntryPopUpOpen(true);
    }

    const showArrearsVerifyPopup = () => {
        setArrearsVerifyPopUpOpen(true);
    }

    const hideObjectionPopup = () => {
        formik.handleReset()
        setObjectionPopUpOpen(false);
    };

    const hideDocVerifyAlert = () => {
        setDocVerifyAlert(false);
    }

    const hideFieldVerifyAlert = () => {
        fieldFormik.resetForm()
        setFieldVerifyAlert(false);
    }

    const hideDnPaymentVerifyAlert = () => {
        setDnPaymentVerifyAlert(false);
    }

    const showRejectionRemovalAlert = () => {
        setRejectionRemovalAlert(true);
    }

    const hideRejectionRemovalAlert = () => {
        setRejectionRemovalAlert(false);
    }

    const hideArrearsEntryAlert = () => {
        setArrearsDetails({
            arrearsAmount: null,
            meterStatus: '',
            tariffDesc: '',
            meterType: '',
            phase: '',
            consumerName: '',
            consumerNo: '',
            consumerAddress: '',
            consumerEmail: '',
        })
        setNoArrears('');
        arearsFormik.values.iv_property_reference_no = ''
        arearsFormik.resetForm()
        setArrearsEntryPopUpOpen(false);
    }

    const hideArrearsVerifyAlert = () => {
        setArrearsVerifyPopUpOpen(false);
    }
    const hideCopyOfApplicantCNICVerifyAlert = (x) => {
        setCopyOfApplicantCNICVerifyPopUp(x);
    }


    const getClassName = (x) => {
        if (x === "Pending") {
            return 'pending-button';
        }
        else if (x === "In Process") {
            return 'inprocess-button';
        }
        else if (x === "Approved") {
            return 'approved-button';
        }
        else if (x === "Objection") {
            return 'objection-button';
        }
    }

    const getApplicationName = (x) => {
        if (x === 1) {
            return "New Connection";
        }
        else if (x === 2) {
            return "Change of Load";
        }
        else if (x === 3) {
            return "Change of Name";
        }
        else if (x === 4) {
            return "Change of Type";
        }
        else if (x === 5) {
            return "Meter Change";
        }
        else if (x === 6) {
            return "Opt for Smart Meter";
        }
        else if (x === 7) {
            return "Due Date Extension";
        }
    }

    const filterNCApp = (applicationId) => {

        const myArray = optApplications

        let itemFound = myArray.find(item => item.applicationId === applicationId)

        return itemFound;
    }

    const convertDate = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const convertDatewithTime = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const hour = date.getHours();
        const minute = date.getMinutes();
        const second = date.getSeconds();
        return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
    }

    const apiToDataGridConversion = () => {
        let sortedData = optApplications.sort((a, b) => {
            const dateA = new Date(a.creationDate);
            const dateB = new Date(b.creationDate);
            return dateB - dateA;
        });
        const tempArray = []
        if (sortedData) {
            sortedData.forEach((item) => {
                let dataGridObject = {}
                if (item.applicationId) {
                    if (item.objectionStatus === 0) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.refNo,
                            "applicantName": item.applicantName,
                            "installmentPlan": item.planName,
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": progFunc(item.applicationProgressId),
                        }
                    }
                    else if (item.objectionStatus === 1) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.refNo,
                            "applicantName": item.applicantName,
                            "installmentPlan": item.planName,
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": item.remarks,
                        }
                    }
                    tempArray.push(dataGridObject)
                }
            })
        }
        else {
            const dataGridObject = {
                "applicationId": ' ',
                "connectionType": '',
                // "appliedLoad": item.appliedLoad,
                // "duration": item.duration,
                "applicantName": ' ',
                "applicantCNIC": ' ',
                "applicationStatusId": statusFunc(' '),
            }
            tempArray.push(dataGridObject)
        }
        setOptApplicationsToDataGrid(tempArray);
    }

    const updateDocumentStatus = () => {

        if (flag_copyOfApplicantCNIC !== null && flag_applicantLastPaidBill !== null) {
            callingUpdateDocumentStatusAPI();
        }
        else {
            console.log("Check all the attached documents before submitting!")
        }
    }

    const updateProgressIdToDocumentsVerified = () => {
        if (flag_copyOfApplicantCNIC === 1 && flag_applicantLastPaidBill === 1) {
            callChangeProgressIdAPI(2, "Documents Verified", "Documents Verified");
            setFlag_copyOfApplicantCNIC(null)
            setFlag_applicantLastPaidBill(null)
        }
        else {
            console.log("Failed to change status for owner industrial Case!")
        }
    }

    const statusFunc = (x, objection) => {
        if (objection === 0) {
            if (x === 0) {
                return 'Pending'
            }
            else if (x > 0 && x < 4) {
                return 'In Process'
            }
            else if (x >= 4) {
                return 'Approved'
            }
        }
        else {
            return 'Objection'
        }
    }

    const progFunc = (x) => {
        if (x === 0) {
            return 'Documents Uploading'
        }
        else if (x === 1) {
            return 'Documents Verification'
        }
        else if (x === 2) {
            return 'Due Amount Verification'
        }
        else if (x === 3) {
            return "Owner's Consent"
        }
        else if (x === 4) {
            return "Owner's Consent Verification"
        }
        else if (x === 5) {
            return 'Demand Note Issued'
        }
        else if (x === 6) {
            return 'DN Payment Verification'
        }
        else if (x === 7) {
            return 'Meter Installation'
        }
        else if (x === 8) {
            return 'Ready for Billing'
        }
    }

    const numberFormatting = (number) => {
        let intNumber = number
        if (typeof number === 'string') {
            intNumber = parseInt(number)
        }
        let formattedNumber = intNumber.toLocaleString(
            undefined,
            {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }
        )
        return formattedNumber
    };

    const docVerificationAlertBox = () => {
        setDocVerifyAlert(true);
    }

    const fieldVerificationAlertBox = () => {
        setFieldVerifyAlert(true);
    }

    const dnPaymentVerificationAlertBox = () => {
        setDnPaymentVerifyAlert(true);
    }

    const handleRowClick = async (applicationId, event) => {
        let mcoDets = '';
        setViewBackdrop(true)
        const item = filterNCApp(applicationId);
        let value = null
        const connectionType = item.connectionType
        const appliedLoad = item.appliedLoad
        let allTariffsArray = allTariffList
        let shortListedTariffsArray = allTariffsArray.filter(item => item.consumerType === connectionType)
        shortListedTariffsArray = shortListedTariffsArray.filter(item => parseInt(item.from) < appliedLoad && parseInt(item.to) > appliedLoad)
        setTariffList(shortListedTariffsArray)
        console.log(item, 'sss')
        setDialogRowData(item);
        setFlag_copyOfApplicantCNIC(item.copyOfApplicantCNICFlag)
        setFlag_applicantLastPaidBill(item.applicantLastPaidBillFlag)

        if (true) {
            var formdata = new FormData();
            formdata.append("applicationId", item.applicationId);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "optForSmartMeter/getOptDocument", requestOptions)
                .then(response => response.json())
                .then(result => {
                    setDialogRowData(prevObject => ({
                        ...prevObject,
                        "copyOfApplicantCNIC": result.data[0].copyOfApplicantCNIC,
                        "applicantLastPaidBill": result.data[0].applicantLastPaidBill,
                    }));

                })
                .catch(error => console.log('error', error));
        }

        if (item.applicationProgressId >= 3) {
            var formdata = new FormData();
            formdata.append("applicationId", applicationId);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "optForSmartMeter/getConsumerConsent", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let concentDetails = result.data[0]
                        fieldFormik.values.iv_consent_image = concentDetails.signedConsumerConsentImage
                        setConsentDetails(concentDetails)
                        setConsentImage(concentDetails.signedConsumerConsentImage)
                        setConsentImageThumbnail(concentDetails.signedConsumerConsentImage)
                    }
                }).catch(error => console.log('error', error));

        }

        if (item.applicationProgressId >= 5) {
            mcoDets = await callGetMCOAPI(item.applicationId)
        }

        setOpen(true)
        setViewBackdrop(false)
    };

    const downloadMCOPDF = async (applicationId) => {
        setViewBackdrop(true)
        // try {
        //     console.log(applicationId, 'printingId')

        //     let mcoDets

        //     await callAsyncGetMCOAPI(applicationId)
        //         .then(response => {
        //             console.log(response, 'printing MCO Details')
        //             mcoDets = response
        //         });

        //     let dnDets
        //     await callAsyncDnDetailsAPI(applicationId)
        //         .then(response => {
        //             console.log(response, 'printing Dn Details')
        //             dnDets = response
        //         });

        //     let application = mcApplications.find(item => item.applicationId === applicationId)
        //     console.log(application, 'PrintingAPp')

        //     const fontSize = 9

        //     const doc = new jsPDF({ compressPdf: true });

        //     if (application.meterPhase === "S-PHASE" || application.meterPhase === "1-PHASE") {
        //         //#region text

        //         //#region Line 1 
        //         var padding = 10
        //         var line2Height = 10
        //         var lineHeightIncreament = 6
        //         doc.setFontSize(fontSize);
        //         doc.text(companyName(applicationId.slice(0, 2)), doc.internal.pageSize.getWidth() / 2, line2Height, {
        //             align: 'center',
        //         });
        //         //#endregion

        //         //#region Line 2
        //         var line2Height = line2Height + lineHeightIncreament
        //         doc.text('Meter Change Order (MCO)', doc.internal.pageSize.getWidth() / 2, line2Height, {
        //             align: 'center',
        //         });
        //         //#endregion

        //         lineHeightIncreament = 8

        //         //#region Line 3
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '                                                                                                                                               MCO No.: '
        //         var text2 = mcoDets.mcoId ? mcoDets.mcoId : '-'
        //         var text3 = application.subDivisionCode ? application.subDivisionCode.toString().concat(' / ').concat(subdivisionName(application.subDivisionCode, subDivisions)) : '-'
        //         var text4 = '                          '

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         //#endregion

        //         //#region Line 4
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 10
        //         text1 = '                                                                                                                                               Issued Date: '
        //         text2 = mcoDets.mcoCreationDate ? convertDate(mcoDets.mcoCreationDate) : '-'
        //         text3 = ''
        //         text4 = application.subDivisionCode ? application.subDivisionCode.toString().concat(' / ').concat(subdivisionName(application.subDivisionCode, subDivisions)) : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         //#endregion

        //         //#region Line 5
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 2
        //         text1 = 'Division Name: '
        //         text2 = '                         ' + (application.applicationId ? divisionName(parseInt(applicationId.slice(0, 4)), subDivisions) : '-') + '                         '
        //         text3 = 'Sub Division Name: '
        //         text4 = '                         ' + (application.creationDate ? subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions) : '-') + '                         '

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 6
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 10
        //         text1 = 'Reference No.: '
        //         text2 = '                         ' + (mcoDets.refNo ? mcoDets.refNo : '-') + '                         '
        //         text3 = 'Batch No.: '
        //         text4 = '                         ' + (mcoDets.batchNo ? mcoDets.batchNo : '-') + '                         '

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

        //         //#endregion

        //         //#region Line 7
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 10
        //         text1 = `Consumer Name: `
        //         text2 = '                    ' + (application.name ? application.name : '-') + '                    '
        //         text3 = 'Cell No.: '
        //         text4 = '                    ' + (application.applicantMobile ? application.applicantMobile : '-') + '                    '
        //         var leftSpace = 50

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 8
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 10
        //         text1 = `Address: `
        //         text2 = '          ' + (application.address ? application.address : '-') + '          '

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 9
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 10
        //         text1 = `Reason for change: `
        //         text2 = '          ' + (application.address ? application.address : '-') + '          '

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 10
        //         line2Height = line2Height + lineHeightIncreament
        //         text1 = `To `
        //         doc.text(text1, padding, line2Height);
        //         //#endregion

        //         //#region Line 10
        //         lineHeightIncreament = 4
        //         line2Height = line2Height + lineHeightIncreament
        //         leftSpace = 20
        //         text1 = `Line Superintendent`
        //         doc.text(text1, padding + leftSpace, line2Height);
        //         //#endregion

        //         //#region Line 10
        //         line2Height = line2Height + lineHeightIncreament
        //         text1 = `Please change meter(s) on premises of above consumer and report`
        //         doc.text(text1, padding + leftSpace, line2Height);
        //         //#endregion

        //         //#region Line 11
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 10
        //         text1 = 'Orderer By: '
        //         text2 = mcoDets.mcoOrderByName ? mcoDets.mcoOrderByName : '-'
        //         leftSpace = 120

        //         doc.text(text1, padding + leftSpace, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 12
        //         doc.setFontSize(12)
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 10
        //         text1 = 'METER REMOVED'
        //         leftSpace = 0
        //         doc.text(text1, padding + leftSpace, line2Height);
        //         //#endregion 

        //         //#region Line 13
        //         doc.setFontSize(fontSize)
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 10
        //         text1 = 'Meter No.:'
        //         text2 = (mcoDets.removedMeterNo ? mcoDets.removedMeterNo.toString() : '-')
        //         text3 = 'Mnfg. Cd.:'
        //         text4 = (mcoDets.removedMnfgCode ? mcoDets.removedMnfgCode.toString() : '-')
        //         var text5 = 'Range:'
        //         var text6 = (mcoDets.removedMeterRange ? mcoDets.removedMeterRange.toString() : '-')
        //         var text7 = 'MF:'
        //         var text8 = (mcoDets.removedMeterMF ? mcoDets.removedMeterMF.toString() : '-')
        //         var text9 = 'Final Reading:'
        //         var text10 = (mcoDets.removedMeterKWHPeak ? mcoDets.removedMeterKWHPeak.toString() : '-')
        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);

        //         doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
        //         doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

        //         doc.text(text7, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + padding + (lineSpace * 6), line2Height);
        //         doc.text(text8, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 7), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 7), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 7) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

        //         doc.text(text9, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + padding + (lineSpace * 9), line2Height);
        //         doc.text(text10, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + doc.getTextWidth(text8) + doc.getTextWidth(text9) + padding + (lineSpace * 9), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 10), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 11) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
        //         //#endregion

        //         //#region Line 12
        //         doc.setFontSize(12)
        //         line2Height = line2Height + lineHeightIncreament + 10
        //         lineSpace = 10
        //         text1 = 'METER INSTALLED'
        //         leftSpace = 0
        //         doc.text(text1, padding + leftSpace, line2Height);
        //         //#endregion 

        //         //#region Line 13
        //         doc.setFontSize(fontSize)
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 10
        //         text1 = 'Meter No.:'
        //         text2 = (mcoDets.installedMeterNo ? mcoDets.installedMeterNo.toString() : '-')
        //         text3 = 'Mnfg. Cd.:'
        //         text4 = (mcoDets.installedMnfgCode ? mcoDets.installedMnfgCode.toString() : '-')
        //         text5 = 'Range:'
        //         text6 = (mcoDets.installedMeterRange ? mcoDets.installedMeterRange.toString() : '-')
        //         text7 = 'MF:'
        //         text8 = (mcoDets.installedMeterMF ? mcoDets.installedMeterMF.toString() : '-')
        //         text9 = 'Final Reading:'
        //         text10 = (mcoDets.installedMeterKWHPeak ? mcoDets.installedMeterKWHPeak.toString() : '-')
        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);

        //         doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
        //         doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

        //         doc.text(text7, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + padding + (lineSpace * 6), line2Height);
        //         doc.text(text8, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 7), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 7), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 7) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

        //         doc.text(text9, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + padding + (lineSpace * 9), line2Height);
        //         doc.text(text10, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + doc.getTextWidth(text8) + doc.getTextWidth(text9) + padding + (lineSpace * 9), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 10), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 11) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
        //         //#endregion

        //         //#region Line 14
        //         lineHeightIncreament = 10
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 10
        //         text1 = `Store Requisition No.: `
        //         text2 = '                     ' + (mcoDets.storeRequisitionNo ? mcoDets.storeRequisitionNo : '-') + '                     '
        //         text3 = 'Requisition Date: '
        //         text4 = '                     ' + (mcoDets.storeRequisitionDate ? convertDate(mcoDets.storeRequisitionDate) : '-') + '                     '
        //         leftSpace = 0

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 13
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 10
        //         text1 = `Item No of CP-Form78 (CA-21): `
        //         text2 = '                    ' + (mcoDetails.cpForm78 ? mcoDetails.cpForm78 : '-') + '                         '

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 14
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 10
        //         text1 = `Item No of CP-Form79 (CA-21): `
        //         text2 = '                    ' + (mcoDetails.cpForm79 ? mcoDetails.cpForm79 : '-') + '                         '

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 15
        //         line2Height = line2Height + lineHeightIncreament
        //         lineSpace = 10
        //         text1 = `Changed By: `
        //         text2 = '                     ' + (mcoDets.meterChangedBy ? mcoDetails.meterChangedBy + ' (' + mcoDets.meterChangedDesignation + ') ' : '-') + '                     '
        //         text3 = 'Execution Date: '
        //         text4 = '                     ' + (mcoDets.meterChangedDate ? convertDate(mcoDets.meterChangedDate) : '-') + '                     '
        //         leftSpace = 0

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#endregion
        //     }
        //     else if (application.meterPhase === "3-PHASE" || application.meterPhase === "THREE-PHASE") {
        //         //#region text

        //         //#region Line 1 
        //         var padding = 10
        //         var line2Height = 10
        //         var lineHeightIncreament = 6
        //         doc.setFontSize(fontSize);
        //         doc.text(companyName(applicationId.slice(0, 2)), doc.internal.pageSize.getWidth() / 2, line2Height, {
        //             align: 'center',
        //         });
        //         //#endregion

        //         //#region Line 2
        //         var line2Height = line2Height + lineHeightIncreament
        //         doc.text('Meter Change Order (SCO)', doc.internal.pageSize.getWidth() / 2, line2Height, {
        //             align: 'center',
        //         });
        //         //#endregion

        //         //#region Line 3
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '1. Sub Division: '
        //         var text2 = application.subDivisionCode ? application.subDivisionCode.toString().concat(' / ').concat(subdivisionName(application.subDivisionCode, subDivisions)) : '-'
        //         var text3 = 'SCO No.: '
        //         var text4 = mcoDets.scoId ? mcoDets.scoId : '-'
        //         var text5 = 'Creation Date: '
        //         var text6 = mcoDets.dateOfAuthorization ? convertDate(mcoDets.dateOfAuthorization) : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
        //         doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
        //         //#endregion

        //         //#region Line 4
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 2
        //         var text1 = '2. Application No.: '
        //         var text2 = application.applicationId ? application.applicationId : '-'
        //         var text3 = 'Date: '
        //         var text4 = application.creationDate ? convertDate(application.creationDate) : '-'
        //         var text5 = 'Tariff: '
        //         var text6 = dnDets.tariff ? dnDets.tariff : '-'
        //         var text7 = mcoDets.fataPata ? mcoDets.fataPata : '-'
        //         var text8 = mcoDets.urbanRural ? mcoDets.urbanRural : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
        //         doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
        //         doc.text(text7, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + padding + (lineSpace * 7), line2Height);
        //         doc.text(text8, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 8), line2Height);
        //         //#endregion

        //         //#region Line 5
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '3. Account No.: '
        //         var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : '-'
        //         var text3 = 'Feeder No.: '
        //         var text4 = mcoDets.feederNo ? mcoDets.feederNo : '-'
        //         var text5 = 'Batch: '
        //         var text6 = mcoDets.batch ? mcoDets.batch : '-'
        //         var text7 = 'Sub Batch: '
        //         var text8 = mcoDets.subBatch ? mcoDets.subBatch : '-'


        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
        //         doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

        //         doc.text(text7, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + padding + (lineSpace * 6), line2Height);
        //         doc.text(text8, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 7), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 6), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 6) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

        //         //#endregion

        //         //#region Line 6
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = `4. Applicant's Name: `
        //         var text2 = application.address ? application.address : '-'
        //         var text3 = 'CNIC/NIC/NICOP: '
        //         var text4 = application.applicantCNIC ? application.applicantCNIC : '-'
        //         var leftSpace = 50

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 7
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = `5. Address: `
        //         var text2 = application.address ? application.address : '-'
        //         var text3 = 'Mobile No.: '
        //         var text4 = application.applicantMobile ? application.applicantMobile : '-'
        //         var leftSpace = 50

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 8
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = `6. Service Connection Cost DN No.: `
        //         var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
        //         var text3 = 'Issuance Date: '
        //         var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
        //         var leftSpace = 35

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 9
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = `7. Security Deposit DN No.: `
        //         var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
        //         var text3 = 'Issuance Date: '
        //         var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
        //         var leftSpace = 47

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 10
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = `8. Amount of Service Connection: `
        //         var text2 = dnDets.meterCost ? numberFormatting(dnDets.meterCost) : '-'
        //         var text3 = 'Payment Date: '
        //         var text4 = dnDets.paymentDate ? convertDate(dnDets.paymentDate) : '-'
        //         var leftSpace = 52

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 11
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = `9. Amount of Security Deposit: `
        //         var text2 = dnDets.securityDepositeAmount ? numberFormatting(dnDets.securityDepositeAmount) : '-'
        //         var text3 = 'Payment Date: '
        //         var text4 = dnDets.paymentDate ? convertDate(dnDets.paymentDate) : '-'
        //         var leftSpace = 56.5

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 12
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '10. F. Govt / Autonomous and Local Bodies under Prov. Govt.: '
        //         var text2 = mcoDets.fGovt ? mcoDets.fGovt : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 13
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '11. Cantonment Board: '
        //         var text2 = mcoDets.cantonmentBoard ? mcoDets.cantonmentBoard : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 14
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '12. Prov. Govt / Autonomous and Local Bodies under Prov Govt.: '
        //         var text2 = mcoDets.pGovt ? mcoDets.pGovt : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 15
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '13. Local Bodies: '
        //         var text2 = mcoDets.localBodies ? mcoDets.localBodies : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 16
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = `14. Authorized By (Name): `
        //         var text2 = userName ? userName : '-'
        //         var text3 = 'Signature: ______________________'
        //         var leftSpace = 62

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         //#endregion

        //         //#region Line 17
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = 'Authorization Date: '
        //         var text2 = mcoDets.dateOfAuthorization ? convertDate(mcoDets.dateOfAuthorization) : '-'
        //         var leftSpace = 122

        //         doc.text(text1, padding + leftSpace, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 18
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = 'Designation: __________________________'
        //         var leftSpace = 122

        //         doc.text(text1, padding + leftSpace, line2Height);
        //         //#endregion

        //         //#region Line 19
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = 'Stamp: ______________________________'
        //         var leftSpace = 122

        //         doc.text(text1, padding + leftSpace, line2Height);
        //         //#endregion

        //         //#region Line 20
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = `15. Store Requisition No.: `
        //         var text2 = mcoDets.storeRequisitionNo ? numberFormatting(mcoDets.storeRequisitionNo) : '-'
        //         var text3 = 'Requisition Date: '
        //         var text4 = mcoDets.storeRequisitionDate ? convertDate(mcoDets.storeRequisitionDate) : '-'
        //         var leftSpace = 56.5

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 21
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '16. Nature as per Standard Classification Code Booklet: '
        //         var text2 = dnDets.tariff ? dnDets.tariff : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 22
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = `17. Seasonal/Non-Seasonal: `
        //         var text2 = mcoDets.seasonalFlag ? mcoDets.seasonalFlag.toString() : '-'
        //         var text3 = 'Sanctioned Load: '
        //         var text4 = dnDets.sanctionLoad ? dnDets.sanctionLoad.toString() : '-'
        //         var leftSpace = 74

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 23
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = `18. No. of meters: `
        //         var text2 = mcoDets.noOfMeters ? mcoDets.noOfMeters.toString() : '-'
        //         var text3 = 'No. of AC/Centrally Air Conditioned Code: '
        //         var text4 = mcoDets.noOfACs ? mcoDets.noOfACs.toString() : '-'
        //         var leftSpace = 57

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 24
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var leftSpace = 18
        //         var text1 = '19. No. of meter sets: '
        //         var text2 = mcoDets.noOfMeterSets ? mcoDets.noOfMeterSets.toString() : '-'
        //         var text3 = 'No. of sub sets: '
        //         var text4 = mcoDets.noOfSubSets ? mcoDets.noOfSubSets.toString() : '-'
        //         var text5 = 'No. of supply points: '
        //         var text6 = mcoDets.noOfSupplyPoints ? mcoDets.noOfSupplyPoints.toString() : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);

        //         doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (leftSpace * 2) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
        //         doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + (leftSpace * 2), line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + (leftSpace * 2), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2) + (leftSpace * 2), line2Height + 1);
        //         //#endregion

        //         //#region Line 25
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '20. Installed Transformer Capacity: '
        //         var text2 = mcoDets.installedTransformerCapacity ? mcoDets.installedTransformerCapacity.toString() : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 26
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '21. Meter Id: '
        //         var text2 = mcoDets.meterId ? mcoDets.meterId.toString() : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 27
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '22. Meter Number: '
        //         var text2 = mcoDets.meterNo ? mcoDets.meterNo.toString() : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 28
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '23. Location Code: '
        //         var text2 = mcoDets.locationCode ? mcoDets.locationCode.toString() : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 29
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '24. Meter Code: '
        //         var text2 = mcoDets.meterCode ? mcoDets.meterCode.toString() : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 30
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '25. Manufacturer Code: '
        //         var text2 = mcoDets.manufacturerCode ? mcoDets.manufacturerCode.toString() : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 31
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '26. Multiplying Factor:: '
        //         var text2 = mcoDets.multiplyingFactor ? mcoDets.multiplyingFactor.toString() : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 32
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '27. Meter Range: '
        //         var text2 = mcoDets.meterRange ? mcoDets.meterRange.toString() : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 33
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '28. Meter Reading: '
        //         var text2 = mcoDets.meterReading ? mcoDets.meterReading.toString() : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 34
        //         var line2Height = line2Height + lineHeightIncreament
        //         doc.text('Note: Where sets are more than one give information (18 to 25) of remaining set on reverse.', doc.internal.pageSize.getWidth() / 2, line2Height, {
        //             align: 'center',
        //         });
        //         //#endregion

        //         //#region Line 35
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = `29. Date of Connection: `
        //         var text2 = mcoDets.dateOfConnection ? convertDate(mcoDets.dateOfConnection) : '-'
        //         var text3 = 'Cp-79 item No.: '
        //         var text4 = mcoDets.cp78ItemNo ? mcoDets.cp78ItemNo.toString() : '-'
        //         var leftSpace = 56.5

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //         //#endregion

        //         //#region Line 36
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var leftSpace = 35
        //         var text1 = '30. Meter Rent: '
        //         var text2 = dnDets.meterRent ? numberFormatting(dnDets.meterRent) : '-'
        //         var text3 = 'Service Rent: '
        //         var text4 = dnDets.serviceRent ? numberFormatting(dnDets.serviceRent) : '-'
        //         var text5 = mcoDets.tieUpNonTieUp ? mcoDets.tieUpNonTieUp === 0 ? 'Non-Tie Up' : 'Tie Up' : '-'


        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);

        //         doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (leftSpace * 2) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
        //         //#endregion

        //         //#region Line 37
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '31. Signature of Consumer in Token of Installation of Connection: ____________________________________________________ '

        //         doc.text(text1, padding, line2Height);
        //         //#endregion

        //         //#region Line 38
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '32. Signature of Consumer in Token of Receipt of Meter Reading Card: ________________________________________________ '

        //         doc.text(text1, padding, line2Height);
        //         //#endregion

        //         //#region Line 39
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '33. Seal on the meter: '
        //         var text2 = mcoDets.sealOnMeter ? mcoDets.sealOnMeter : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 40
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '34. Seal on the box: '
        //         var text2 = mcoDets.sealOnBox ? mcoDets.sealOnBox : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 41
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '34-A. Security Slip / Price Bond No.: '
        //         var text2 = mcoDets.securitySlipOrPriceBondNo ? mcoDets.securitySlipOrPriceBondNo.toString() : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 42
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = '35. Connection Installed By: '
        //         var text2 = mcoDets.connectionInstallerName ? mcoDets.connectionInstallerName : '-'

        //         doc.text(text1, padding, line2Height);
        //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //         //#endregion

        //         //#region Line 43
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = 'Signature: __________________________'
        //         var leftSpace = 122

        //         doc.text(text1, padding + leftSpace, line2Height);
        //         //#endregion

        //         //#region Line 44
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = 'Designation: ________________________'
        //         var leftSpace = 122

        //         doc.text(text1, padding + leftSpace, line2Height);
        //         //#endregion

        //         //#region Line 45  
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = 'Stamp: ____________________________'
        //         var leftSpace = 122

        //         doc.text(text1, padding + leftSpace, line2Height);
        //         //#endregion

        //         //#region Line 46
        //         var line2Height = line2Height + lineHeightIncreament
        //         var lineSpace = 10
        //         var text1 = 'UserName: '

        //         doc.text(text1, padding, line2Height);
        //         doc.text(userName, padding + doc.getTextWidth(text1), line2Height);
        //         //#endregion

        //         //#endregion
        //     }

        //     const totalPages = doc.internal.getNumberOfPages();

        //     for (let i = 1; i <= totalPages; i++) {
        //         doc.setPage(i);
        //         doc.addImage(getWaterMarkLogo(userCompany), 'PNG', 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
        //     }

        //     // Save the PDF
        //     doc.save(applicationId + '- SCO.pdf');
        // }
        // catch (e) {
        //     console.log("Unable to generate Master Data Form!", e)
        // }
        setViewBackdrop(false)
    };

    const RemovedMeterImage = (event) => {
        // console.log('in applicant cnic functiuon')
        // mcoPart2Formik.handleChange(event);
        mcoPart2Formik.values.iv_removed_Meter_Image = 'uploaded'
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            setRemovedMeterImageFileName(fileName)
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            // console.log(extension, 'Printing Extension');
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "RemovedMeterImage." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setRemovedMeterImage(renamedFile);
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    mcoPart2Formik.values.iv_removed_Meter_Image = 'uploaded'
                    setRemovedMeterImageThumbnail(e.target.result);
                    // setPropertyDocumentsBase64(e.target.result.split(',')[1])
                };

                reader.readAsDataURL(file);

            } else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    };

    const InstalledMeterImage = (event) => {
        // console.log('in applicant cnic functiuon')
        mcoPart2Formik.values.iv_installed_Meter_Image = 'uploaded'
        // mcoPart2Formik.handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            setInstalledMeterImageFileName(fileName)
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            // console.log(extension, 'Printing Extension');
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "InstalledMeterImage." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setInstalledMeterImage(renamedFile);
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    mcoPart2Formik.values.iv_installed_Meter_Image = 'uploaded'
                    setInstalledMeterImageThumbnail(e.target.result);
                    // setPropertyDocumentsBase64(e.target.result.split(',')[1])
                };

                reader.readAsDataURL(file);

            } else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    };

    let batchArray = [
        '01', '02', '03', '04', '05', '06', '07', '08', '09', '10',
        '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
        '21', '22', '23', '24', '25', '26', '27', '28', '29', '30',
        '31', '32', '33', '34', '35', '36', '37', '38', '39', '40',
        '41', '42', '43', '44', '45', '46',
    ]

    const callMCOApprovePart1API = async (scoId) => {
        var formdata = new FormData();
        formdata.append("mcoId", scoId);
        formdata.append("mcoOrderByName", userName);
        formdata.append("mcoOrderFlag", 1);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "mco/mcoP1Ordered", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    // toast.success(result.message)
                    callChangeProgressIdAPI(6, "MCO Ordered", "MCO Ordered")
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error =>
                console.log(error)
            );
    };

    const callMCOApprovePart2API = async (mcoId) => {
        var formdata = new FormData();
        formdata.append("mcoId", mcoId);
        formdata.append("mcoP2approvedBy", userName);
        formdata.append("mcoP2approvedFlag", 1);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "mco/mcoP2Ordered", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    // toast.success(result.message)
                    var formdata = new FormData();
                    formdata.append("applicationId", dialogRowData.applicationId);
                    formdata.append("cp136Type", 2);
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);;

                    var requestOptions = {
                        method: 'POST',
                        body: formdata,
                        headers: myHeaders,
                        redirect: 'follow',
                    };
                    fetch(cfpBaseUrl + "cpForm136/cp136Creation", requestOptions)
                        .then(response => response.json())
                        .then(result => {
                            if (result.status === "200") {
                                callChangeProgressIdAPI(7, 'Meter Replaced', "Meter Replaced")
                                // toast.success(result.message)
                            }
                            else {
                                console.log(result.message)
                            }
                        })
                        .catch(error => {
                            console.log(error)
                        });
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error =>
                console.log(error)
            );
    };

    const referenceNumberHandleChange = (event) => {
        setReferenceNumberToAllot(event.target.value)
    };


    //#endregion

    //#region formiks

    const arearsFormik =
        useFormik({
            initialValues,
            validationSchema: Yup.object({
                iv_property_reference_no: Yup.string().required("Enter the reference number to get arrear details.").min(14, "Enter 14 digit reference number.").max(14, "Enter 14 digit reference number."),
            }),
            onSubmit: (values, { resetForm }) => {
                callObjectionRemarksAPI("Arears Objection")
                resetForm()
                setArrearsEntryPopUpOpen(false);
            }
        });

    const fieldFormik =
        useFormik({
            initialValues,
            validationSchema: Yup.object({
                iv_consent_submitted: Yup.string().required("Select option for the consent submitted."),
                iv_consent_image: Yup.mixed().required('Upload consent image.'),
            }),
            onSubmit: (values, { resetForm }) => {
                var formdata = new FormData();
                console.log("applicationId", dialogRowData.applicationId);
                console.log("isConsumerConsentSigned", values.iv_consent_submitted);
                console.log("signedConsumerConsentImage", consentImageThumbnail);
                console.log("consumerConsentFilledBy", userName);
                console.log("token", token);

                formdata.append("applicationId", dialogRowData.applicationId);
                formdata.append("isConsumerConsentSigned", values.iv_consent_submitted);
                formdata.append("signedConsumerConsentImage", consentImageThumbnail);
                formdata.append("consumerConsentFilledBy", userName);
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);;

                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow',
                };

                fetch(cfpBaseUrl + "optForSmartMeter/consumerConsentData", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            if (consentDetails.consumerConsentFillFlag === null || consentDetails.consumerConsentFillFlag === undefined) {
                                callChangeProgressIdAPI(4, "Owner Concent Filled", "Owner Consent Filled");
                                setConsentImage(consentImageThumbnail)
                            }
                            // toast.success(result.message)
                            if (consentDetails.consumerConsentFillFlag === 1) {
                                console.log('isnide')
                                callConsentApprovalAPI(dialogRowData.applicationId)
                                callMCOCreationAPI(dialogRowData.applicationId)

                            }
                        }
                        else {
                            console.log(result.message)
                        }
                    })
                    .catch(error => console.log('error', error));
                resetForm();
                // setConsentImage('')
                // setConsentImageThumbnail(null)
                setShowConsentForm(false)
                setOpen(false)
            }
        });

    const formik =
        useFormik({
            initialValues,
            validationSchema: Yup.object({
                iv_objection_Type: Yup.mixed().required("Select the objection from list.").oneOf(fieldObjections, 'Please select a valid option'),
                // iv_objection_Descripton: Yup.string().max(500, "Objection details has a limit of maximum 500 characters.").required("Please enter understandable objection details."),
            }),
            onSubmit: (values, { resetForm }) => {
                var formdata = new FormData();
                formdata.append("applicationId", dialogRowData.applicationId);
                formdata.append("remarks", objectionType);
                formdata.append("remarksDetail", values.iv_objection_Descripton);

                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);

                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow',
                };

                fetch(cfpBaseUrl + "electricityNewConnection/objectionRemarks", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === '200') {
                            // console.log('Status Updated')
                            let lclStrdNewConApp = JSON.parse(window.localStorage.getItem('new-connection-applications'));
                            const index = lclStrdNewConApp.findIndex(item => item.applicationId === dialogRowData.applicationId);
                            lclStrdNewConApp[index].objectionStatus = 1
                            lclStrdNewConApp[index].remarks = values.iv_objection_Type
                            lclStrdNewConApp[index].remarksDetail = values.iv_objection_Descripton
                            window.localStorage.setItem('new-connection-applications', JSON.stringify(lclStrdNewConApp));
                            //setNewConnectionApplications(JSON.parse(window.localStorage.getItem('new-connection-applications')));
                            // toast.success("Objection Saved for application: " + dialogRowData.applicationId + ".")
                            setObjectionPopUpOpen(false);
                            setOpen(false);
                            resetForm();
                        }
                        else {
                            console.log(result.message)
                        }
                    })
                    .catch(error => console.log('error', error));
            }
        })

    //#endregion

    const mcoPart1Formik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_batch: Yup.mixed().required("Select batch."),
            iv_memo_number: Yup.number().required('Enter MEMO number.'),
            iv_memo_date: Yup.string().required('Select MEMO date.'),
            // iv_mt_number: Yup.string().required('Enter M & T number.'),
            // iv_mt_date: Yup.string().required('Select M & T date.')
        }),
        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true)
            var formdata = new FormData();
            console.log("mcoId", mcoDetails.mcoId);
            console.log("refNo", dialogRowData.refNo);
            console.log("meterType", dialogRowData.meterType);
            console.log("batchNo", values.iv_batch);
            console.log("consumerName", dialogRowData.applicantName);
            console.log("address", dialogRowData.address);
            console.log("MEMoNo", values.iv_memo_number);
            console.log("MEMODate", values.iv_memo_date);
            console.log("reason", dialogRowData.meterChangeType);
            console.log("mtNo", values.iv_mt_number);
            console.log("mtDate", values.iv_mt_date);
            console.log("mcoP1FilledBy", userName);
            console.log("mcoP1FilledFlag", 1);
            console.log("token", token);

            formdata.append("mcoId", mcoDetails.mcoId);
            formdata.append("refNo", dialogRowData.refNo);
            formdata.append("meterType", dialogRowData.meterType);
            formdata.append("batchNo", values.iv_batch);
            formdata.append("consumerName", dialogRowData.applicantName);
            formdata.append("address", dialogRowData.address);
            formdata.append("MEMoNo", values.iv_memo_number);
            formdata.append("MEMODate", values.iv_memo_date);
            formdata.append("reason", dialogRowData.meterChangeType);
            formdata.append("mtNo", values.iv_mt_number);
            formdata.append("mtDate", values.iv_mt_date);
            formdata.append("mcoP1FilledBy", userName);
            formdata.append("mcoP1FilledFlag", 1);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "mco/mcoP1DataInsert", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        if (mcoDetails.mcoP1FilledFlag === null) {
                            // toast.success(result.message)
                            setOpen(false)
                        }
                        else {
                            callMCOApprovePart1API(mcoDetails.mcoId)
                            setOpen(false)
                        }
                        mcoPart1Formik.resetForm()
                    }
                    else {
                        console.log(result.message)
                    }
                })
                .catch(error =>
                    console.log(error)
                );
            setViewBackdrop(false);
        }
    });

    const mcoPart2Formik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_removed_Meter_No: Yup.string().optional('Enter meter number.').min(7, 'Meter no. should be 7 digits.').max(10, 'Meter no. should be 10 digits.').matches(/^[0-9]+$/, "Meter no. should be number only."),
            // iv_removed_Mnfg_Code: Yup.number().optional('Enter removed meter code.'),
            iv_removed_Meter_MF: Yup.number().max(1000, "Multiplying factor can not be more than 1000.").min(1, 'Multiplying factor can not be less than 1.').optional("Enter multiplying factor."),
            iv_removed_Meter_Range: Yup.string().max(4, "Meter range can not be more than 9999.").min(1, 'Meter range can not be less than 1.').optional("Enter meter range.").matches(/^[0-9]+$/, "Enter meter range in numbers."),
            iv_removed_Meter_KWH_Peak: Yup.number().optional('Enter removed meter kWh peak.'),
            iv_removed_Meter_KWH_OffPeak: Yup.number().optional('Enter removed meter kWh offpeak.'),
            iv_removed_Meter_KVARH_Peak: Yup.number().optional('Enter removed meter kVarh peak.'),
            iv_removed_Meter_KVARH_OffPeak: Yup.number().optional('Enter removed meter kVarh offpeak.'),
            iv_removed_Meter_MDI_SUMPeak: Yup.number().optional('Enter removed meter MDI peak.'),
            iv_removed_Meter_MDI_SUMOffPeak: Yup.number().optional('Enter removed meter MDI offpeak.'),
            iv_removed_Meter_Image: Yup.string().optional('Upload removed meter image.'),
            iv_reset_No: Yup.string().optional('Enter removed meter reset no.'),
            iv_installed_Meter_No: Yup.string().optional('Enter meter number.').min(7, 'Meter no. should be 7 digits.').max(10, 'Meter no. should be 10 digits.').matches(/^[0-9]+$/, "Meter no. should be number only."),
            // iv_installed_Meter_Mnfg_Code: Yup.string().optional('Enter installed meter manufacturer code.'),
            iv_installed_Meter_MF: Yup.number().max(1000, "Multiplying factor can not be more than 1000.").min(1, 'Multiplying factor can not be less than 1.').optional("Enter multiplying factor."),
            iv_installed_Meter_Range: Yup.string().max(4, "Meter range can not be more than 9999.").min(1, 'Meter range can not be less than 1.').optional("Enter meter range.").matches(/^[0-9]+$/, "Enter meter range in numbers."),
            iv_installed_Meter_KWH_Peak: Yup.number().optional('Enter installed meter kWh peak.'),
            iv_installed_Meter_KWH_OffPeak: Yup.number().optional('Enter installed meter kWh offpeak.'),
            iv_installed_Meter_KVARH_Peak: Yup.number().optional('Enter installed meter kVarh peak.'),
            iv_installed_Meter_KVARH_OffPeak: Yup.number().optional('Enter installed meter kVarh offpeak.'),
            iv_installed_Meter_MDI_SUM_Peak: Yup.number().optional('Enter installed meter MDI peak.'),
            iv_installed_Meter_MDI_SUM_OffPeak: Yup.number().optional('Enter installed meter MDI offpeak.'),
            iv_installed_Meter_Reset_No: Yup.string().optional('Enter installed meter reset no.'),
            iv_installed_Meter_Image: Yup.string().optional('Upload installed meter image.'),
            iv_checking_Report_No: Yup.number().optional('Enter checking report no.'),
            iv_checking_Report_Date: Yup.string().optional('Enter checking report date.'),
            iv_store_requisition_no: Yup.string().optional('Enter store requision no.'),
            iv_store_requisition_date: Yup.string().optional('Enter store requisition date.'),
            iv_cp_Form_78: Yup.string().optional(),
            iv_cp_Form_79: Yup.string().optional(),
            iv_ca21: Yup.string().optional(),
            iv_ca22: Yup.string().optional(),
            iv_meter_Changed_By: Yup.string().optional('Enter meter changed by name.'),
            iv_meter_Changed_Designation: Yup.string().optional('Enter meter change by designation.'),
            iv_meter_Changed_Date: Yup.string().optional('Enter meter change date.'),
        }),
        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true)
            console.log("mcoId", mcoDetails.mcoId);
            console.log("removedMeterNo", mcoPart2Formik.values.iv_removed_Meter_No);
            console.log("removedMnfgCode", mcoPart2Formik.values.iv_removed_Mnfg_Code);
            console.log("removedMeterMF", mcoPart2Formik.values.iv_removed_Meter_MF);
            console.log("removedMeterRange", mcoPart2Formik.values.iv_removed_Meter_Range);
            console.log("removedMeterKWHPeak", mcoPart2Formik.values.iv_removed_Meter_KWH_Peak);
            console.log("removedMeterKWHOffPeak", mcoPart2Formik.values.iv_removed_Meter_KWH_OffPeak);
            console.log("removedMeterKVARHPeak", mcoPart2Formik.values.iv_removed_Meter_KVARH_Peak);
            console.log("removedMeterKVARHOffPeak", mcoPart2Formik.values.iv_removed_Meter_KVARH_OffPeak);
            console.log("removedMeterMDISUMPeak", mcoPart2Formik.values.iv_removed_Meter_MDI_SUMPeak);
            console.log("removedMeterMDISUMOffPeak", mcoPart2Formik.values.iv_removed_Meter_MDI_SUMOffPeak);
            console.log("removedMeterImage", removedMeterImageThumbnail);
            console.log("resetNo", mcoPart2Formik.values.iv_reset_No);
            console.log("installedMeterNo", mcoPart2Formik.values.iv_installed_Meter_No);
            console.log("installedMnfgCode", mcoPart2Formik.values.iv_installed_Meter_Mnfg_Code);
            console.log("installedMeterMF", mcoPart2Formik.values.iv_installed_Meter_MF);
            console.log("installedMeterRange", mcoPart2Formik.values.iv_installed_Meter_Range);
            console.log("installedMeterKWHPeak", mcoPart2Formik.values.iv_installed_Meter_KWH_Peak);
            console.log("installedMeterKWHOffPeak", mcoPart2Formik.values.iv_installed_Meter_KWH_OffPeak);
            console.log("installedMeterKVARHPeak", mcoPart2Formik.values.iv_installed_Meter_KVARH_Peak);
            console.log("installedMeterKVARHOffPeak", mcoPart2Formik.values.iv_installed_Meter_KVARH_OffPeak);
            console.log("installedMeterMDISUMPeak", mcoPart2Formik.values.iv_installed_Meter_MDI_SUM_Peak);
            console.log("installedMeterMDISUMOffPeak", mcoPart2Formik.values.iv_installed_Meter_MDI_SUM_OffPeak);
            console.log("installedMeterResetNo", mcoPart2Formik.values.iv_installed_Meter_Reset_No);
            console.log("installedMeterImage", installedMeterImageThumbnail);
            console.log("checkingReportNo", mcoPart2Formik.values.iv_checking_Report_No);
            console.log("checkingReportDate", mcoPart2Formik.values.iv_checking_Report_Date);
            console.log("storeRequisitionNo", mcoPart2Formik.values.iv_store_requisition_no);
            console.log("storeRequisitionDate", mcoPart2Formik.values.iv_store_requisition_date);
            console.log("cpForm78", mcoPart2Formik.values.iv_cp_Form_78);
            console.log("cpForm79", mcoPart2Formik.values.iv_cp_Form_79);
            console.log("ca21", mcoPart2Formik.values.iv_ca21);
            console.log("ca22", mcoPart2Formik.values.iv_ca22);
            console.log("meterChangedBy", mcoPart2Formik.values.iv_meter_Changed_By);
            console.log("meterChangedDesignation", mcoPart2Formik.values.iv_meter_Changed_Designation);
            console.log("meterChangedDate", mcoPart2Formik.values.iv_meter_Changed_Date);
            console.log("complianceBy", userName);
            console.log("complianceFlag", 1);
            console.log("token", token);

            var formdata = new FormData();
            formdata.append("mcoId", mcoDetails.mcoId);
            formdata.append("removedMeterNo", mcoPart2Formik.values.iv_removed_Meter_No);
            formdata.append("removedMnfgCode", mcoPart2Formik.values.iv_removed_Mnfg_Code);
            formdata.append("removedMeterMF", mcoPart2Formik.values.iv_removed_Meter_MF);
            formdata.append("removedMeterRange", mcoPart2Formik.values.iv_removed_Meter_Range);
            formdata.append("removedMeterKWHPeak", mcoPart2Formik.values.iv_removed_Meter_KWH_Peak);
            formdata.append("removedMeterKWHOffPeak", mcoPart2Formik.values.iv_removed_Meter_KWH_OffPeak);
            formdata.append("removedMeterKVARHPeak", mcoPart2Formik.values.iv_removed_Meter_KVARH_Peak);
            formdata.append("removedMeterKVARHOffPeak", mcoPart2Formik.values.iv_removed_Meter_KVARH_OffPeak);
            formdata.append("removedMeterMDISUMPeak", mcoPart2Formik.values.iv_removed_Meter_MDI_SUMPeak);
            formdata.append("removedMeterMDISUMOffPeak", mcoPart2Formik.values.iv_removed_Meter_MDI_SUMOffPeak);
            formdata.append("removedMeterImage", removedMeterImageThumbnail);
            formdata.append("resetNo", mcoPart2Formik.values.iv_reset_No);
            formdata.append("installedMeterNo", mcoPart2Formik.values.iv_installed_Meter_No);
            formdata.append("installedMnfgCode", mcoPart2Formik.values.iv_installed_Meter_Mnfg_Code);
            formdata.append("installedMeterMF", mcoPart2Formik.values.iv_installed_Meter_MF);
            formdata.append("installedMeterRange", mcoPart2Formik.values.iv_installed_Meter_Range);
            formdata.append("installedMeterKWHPeak", mcoPart2Formik.values.iv_installed_Meter_KWH_Peak);
            formdata.append("installedMeterKWHOffPeak", mcoPart2Formik.values.iv_installed_Meter_KWH_OffPeak);
            formdata.append("installedMeterKVARHPeak", mcoPart2Formik.values.iv_installed_Meter_KVARH_Peak);
            formdata.append("installedMeterKVARHOffPeak", mcoPart2Formik.values.iv_installed_Meter_KVARH_OffPeak);
            formdata.append("installedMeterMDISUMPeak", mcoPart2Formik.values.iv_installed_Meter_MDI_SUM_Peak);
            formdata.append("installedMeterMDISUMOffPeak", mcoPart2Formik.values.iv_installed_Meter_MDI_SUM_OffPeak);
            formdata.append("installedMeterResetNo", mcoPart2Formik.values.iv_installed_Meter_Reset_No);
            formdata.append("installedMeterImage", installedMeterImageThumbnail);
            formdata.append("checkingReportNo", mcoPart2Formik.values.iv_checking_Report_No);
            formdata.append("checkingReportDate", mcoPart2Formik.values.iv_checking_Report_Date);
            formdata.append("storeRequisitionNo", mcoPart2Formik.values.iv_store_requisition_no);
            formdata.append("storeRequisitionDate", mcoPart2Formik.values.iv_store_requisition_date);
            formdata.append("cpForm78", mcoPart2Formik.values.iv_cp_Form_78);
            formdata.append("cpForm79", mcoPart2Formik.values.iv_cp_Form_79);
            formdata.append("ca21", mcoPart2Formik.values.iv_ca21);
            formdata.append("ca22", mcoPart2Formik.values.iv_ca22);
            formdata.append("meterChangedBy", mcoPart2Formik.values.iv_meter_Changed_By);
            formdata.append("meterChangedDesignation", mcoPart2Formik.values.iv_meter_Changed_Designation);
            formdata.append("meterChangedDate", mcoPart2Formik.values.iv_meter_Changed_Date);
            formdata.append("complianceBy", userName);
            formdata.append("complianceFlag", 1);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "mco/mcoP2DataInsert", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        if (mcoDetails.complianceFlag === null) {
                            resetForm()
                            // toast.success(result.message)
                            setOpen(false)
                        }
                        else {
                            resetForm()
                            callMCOApprovePart2API(mcoDetails.mcoId)
                            setOpen(false)
                        }
                    }
                    else {
                        console.log(result.message)
                    }
                })
                .catch(error =>
                    console.log(error)
                );
            setViewBackdrop(false)
        }
    });
    //#region useEffects

    // useEffect(() => {
    //     callTariffList()
    // }, [])

    useEffect(() => {
        if (arearsFormik.values.iv_property_reference_no.length === 14) {
            // console.log(arearsFormik.values.iv_property_reference_no, '<-- Inside UseEffect')
            referenceApi();
        }
        else {
            let emptyArearObject = {
                arrearsAmount: '',
                meterStatus: '',
                tariffDesc: '',
                meterType: '',
                phase: '',
                consumerName: '',
                consumerNo: "",
                consumerAddress: '',
                consumerEmail: '',
            }
            setArrearsDetails(emptyArearObject);
            setNoArrears('');
            return
        }
    }, [arearsFormik.values.iv_property_reference_no])

    useEffect(() => {
        setOptApplications(JSON.parse(window.localStorage.getItem('opt-for-smart-meter-applications')));
    }, [])
    const hidePropertyDocVerifyAlert = (x) => {
        console.log(propertyDocVerifyPopUp, 'printing doc verify popup in function')
        console.log(x, 'pringitn x')
        setPropertyDocVerifyPopUp(x);
    }

    useEffect(() => {
        if (optApplications) {
            apiToDataGridConversion()
        }
    }, [optApplications]);

    useEffect(() => {
        if (optApplications) {
            apiToDataGridConversion()
        }
    }, [optApplications]);

    useEffect(() => {
        // console.log(referenceNumberToAllot.length, "Reference number to allot")
        if (referenceNumberToAllot.length === 9) {
            fieldFormik.values.iv_reference_to_allot = partialValue + referenceNumberToAllot
            // console.log(fieldFormik.values.iv_reference_to_allot, 'Ref Ini value')
        }
        else {
            fieldFormik.values.iv_reference_to_allot = partialValue
        }
    }, [referenceNumberToAllot])

    useEffect(() => {
        setPartialValue(dialogRowData.subDivisionCode)
    }, [dialogRowData])

    useEffect(() => {
        if (foundId && foundId != '') {
            let allApps = JSON.parse(window.localStorage.getItem('opt-for-smart-meter-applications'));

            if (allApps) {
                setOptApplications(allApps)
            }
        }
    }, [foundId])

    useEffect(() => {
        if (optApplications.length >= 1) {
            if (foundId && foundId != '') {
                console.log(foundId, 'printing Id in new connection')
                console.log(optApplications, 'printing all apps')
                const optApp = optApplications.find(item => item.applicationId === foundId)
                console.log(optApp)
                setDialogRowData(optApp)
                setOpen(true)
            }
        }
    }, [optApplications])

    //#endregion

    const tblColumns = [
        { field: "applicationId", headerName: 'Application No.', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "creationDate", type: 'dateTime', headerName: 'Submission Date', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "referenceNo", headerName: 'Reference No.', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "applicantName", headerName: 'Applicant Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "installmentPlan", type: 'singleSelect', valueOptions: ['One Time Payment', '3 Month Installment', '6 Month Installment'], headerName: 'Installment Plan', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "applicationStatusId", headerName: 'Status', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        {
            field: "action",
            headerName: "Status",
            sortable: false,
            type: 'singleSelect',
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            valueOptions: [1, 2, 3],
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                let btnText = (params.applicationStatusId)
                return (
                    <div className={getClassName(btnText)} >{btnText}</div>
                )
            }
        },
        { field: "applicationProgressId", headerName: 'Description', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    ]
    const openDetailsPopUp = async (stepName) => {
        console.log(dialogRowData.applicationId, 'printing Id in function')
        let id = dialogRowData.applicationId

        if (stepName === "Documents Verified" || stepName === "DOCUMENT VERIFICATION") {
            setDocumentsVerifiedSubPopUp(true)
        }
        else if (stepName === "Due Amount Verified" || stepName === "DUE AMOUNT VERIFICATION") {
            setArrearVerifiedSubPopUp(true)
        }
        else if (stepName === "Owner Consent" || stepName === "OWNER CONSENT") {
            // await callAsyncFieldSurveyInformation(dialogRowData.applicationId)
            setFieldSurveyedSubPopUp(true)
        }
        else if (stepName === "Owner Consent Verification" || stepName === "OWNER CONSENT VERIFICATION") {
            // await callAsyncFieldSurveyInformation(dialogRowData.applicationId)
            setFieldSurveyedSubPopUp(true)
        }



        else if (stepName === "Meter Change Order" || stepName === "METER CHANGE ORDER") {
            // await callAsyncDnDetailsAPI(dialogRowData.applicationId)
            setReferenceNoAllocatedSubPopUp(true)
        }
        else if (stepName === " Meter Installation" || stepName === " METER INSTALLATION") {
            // await callAsyncDnDetailsAPI(dialogRowData.applicationId)
            setReferenceNoAllocatedSubPopUp(true)
        }
        else if (stepName === "Mco Effection & Ready For Billing" || stepName === "MCO EFFECTION & READY FOR BILLING") {
            // await callAsyncGetPaidDnImageAPI(dialogRowData.applicationId)
            setDnPaymentSubmittedSubPopUp(true)
        }
        // else if (stepName === "Billing Converison To Smart Meter" || stepName === "BILLING CONVERSION TO SMART METER") {
        //     // await callAsyncGetPaidDnImageAPI(dialogRowData.applicationId)
        //     setDnPaymentVerifiedSubPopUp(true)
        // }

    }

    let NCStatusBarArray = [
        {
            title1: 'DOCUMENT',
            title2: 'SUBMISSION',
        },
        {
            title1: 'DOCUMENT',
            title2: 'VERIFICATION',
        },
        {
            title1: 'DUE AMOUNT',
            title2: 'VERIFICATION',
        },
        {
            title1: 'OWNER',
            title2: 'CONSENT',
        },
        {
            title1: 'OWNER',
            title2: 'CONSENT VERIFICATION',
        },
        {
            title1: 'METER CHANGE ORDER',
        },
        {
            title1: 'METER INSTALLATION',
        },
        {
            title1: 'MCO EFFECTION &',
            title2: 'READY FOR BILLING',
        },
        // {
        //     title1: 'BILLING CONVERSION',
        //     title2: 'TO SMART METER',
        // },

    ]

    const callAsyncGetDocumentsAPI = async (applicationId) => {
        try {

            let appDocs = {}
            var formdata = new FormData();
            formdata.append("applicationId", applicationId);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "electricityNewConnection/getDocuments", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        appDocs = result.images[0]
                    }
                })
                .catch(error => console.log('error', error));

            return appDocs
        }
        catch (e) {
            console.log(e, 'Unable to get Master Form Data!')
        }
    }

    const downloadApplicationPDF = async (applicationId) => {
        setViewBackdrop(true)
        try {

            let application = newConnectionApplications.find(item => item.applicationId === applicationId)
            console.log(application, 'PrintingAPp')
            let applicationDocs;

            await callAsyncGetDocumentsAPI(applicationId)
                .then(response => {
                    console.log(response, 'printing Documents')
                    applicationDocs = response;
                })

            //#region text
            const copyOfApplicantCNICFront = applicationDocs.copyOfApplicantCNICFront ? applicationDocs.copyOfApplicantCNICFront : ''
            const copyOfApplicantCNICBack = applicationDocs.copyOfApplicantCNICBack ? applicationDocs.copyOfApplicantCNICBack : ''
            const premisesDocument = applicationDocs.premisesDocument ? applicationDocs.premisesDocument : ''
            const scannedCopyOfNearByElectricityBill = applicationDocs.scannedCopyOfNearByElectricityBill ? applicationDocs.scannedCopyOfNearByElectricityBill : ''
            const copyOfOwnerCNICFront = applicationDocs.copyOfOwnerCNICFront ? applicationDocs.copyOfOwnerCNICFront : ''
            const copyOfOwnerCNICBack = applicationDocs.copyOfOwnerCNICBack ? applicationDocs.copyOfOwnerCNICBack : ''
            const ownerNOC = applicationDocs.ownerNOC ? applicationDocs.ownerNOC : ''
            const resolutionFormDesc = applicationDocs.resolutionFormDesc ? applicationDocs.resolutionFormDesc : ''
            const certMemoDesc = applicationDocs.certMemoDesc ? applicationDocs.certMemoDesc : ''
            const certFormDesc = applicationDocs.certFormDesc ? applicationDocs.certFormDesc : ''

            const doc = new jsPDF({ compressPdf: true });


            const addPdfasImage = async (pdfInBase64, document) => {
                let docPageNumbers = null
                let base64ImagesArray = []

                GlobalWorkerOptions.workerSrc = '../../../services/pdf.worker.mjs';

                const pdfData = atob(pdfInBase64.split(',')[1]);

                // Find the number of pages in the PDF
                const regex = /\/Count\s+(\d+)/;
                const match = pdfData.match(regex);
                const pageCount = match ? parseInt(match[1], 10) : 0;

                docPageNumbers = pageCount;

                const renderPageToBase64 = async (pageNumber) => {
                    try {
                        // Load the PDF page
                        const pdf = await getDocument({ data: pdfData }).promise;
                        const pdfPage = await pdf.getPage(pageNumber);

                        // Render the PDF page to a canvas
                        const scale = 1.5; // Adjust as needed
                        const viewport = pdfPage.getViewport({ scale });
                        const canvas = document.createElement('canvas');
                        const canvasContext = canvas.getContext('2d');
                        canvas.width = viewport.width;
                        canvas.height = viewport.height;
                        await pdfPage.render({ canvasContext, viewport }).promise;

                        // Convert the canvas to a base64-encoded image
                        const imageDataUrl = canvas.toDataURL('image/png');
                        return imageDataUrl;
                    } catch (error) {
                        console.error('Error rendering PDF page:', error);
                    }
                };

                for (let i = 1; i <= docPageNumbers; i++) {
                    const imageDataUrl = await renderPageToBase64(i);
                    console.log(imageDataUrl, 'printing render function output')
                    base64ImagesArray.push(imageDataUrl);
                }

                base64ImagesArray.forEach((imageDataUrl, index) => {
                    console.log(imageDataUrl, 'printing data url')
                    doc.addImage(imageDataUrl, 'png', 10, 10, 100, 100); // Adjust the coordinates and dimensions as needed
                    if (index !== base64ImagesArray.length - 1) {
                        doc.addPage();
                    }
                });

            }

            var pageWidth = doc.internal.pageSize.getWidth();
            var pageHeight = doc.internal.pageSize.getHeight();

            // Generate the barcode image using JsBarcode
            const barcodeCanvas = document.createElement('canvas');
            JsBarcode(barcodeCanvas, applicationId);

            // Convert the barcode image to data URL
            const barcodeDataURL = barcodeCanvas.toDataURL('image/png');
            var height = 10;
            var padding = 10;

            // Add the barcode image to the PDF document
            doc.addImage(barcodeDataURL, 'PNG', 85, 260, 40, 20); // Adjust the position and size of the barcode image
            doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image


            var increment = 15;
            height = height + increment
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });

            increment = 8;
            height = height + increment;
            doc.setFontSize(18);
            doc.text('E-Document', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });

            height = height + increment;
            doc.setFontSize(12);
            doc.setFont('helvetica', 'normal');
            var increment = 8;
            var height = height + increment
            var leftMargin = 50
            doc.text('Document Type: ', padding, height);
            doc.text('New Connection', padding + leftMargin, height);
            doc.text('Tracking Id:', padding + leftMargin + leftMargin, height);
            doc.text(applicationId, padding + leftMargin + leftMargin + leftMargin, height);

            var increment = 6;
            var height = height + increment;
            doc.text('Application Status: ', padding, height);
            doc.text(statusFunc(application.applicationProgressId, application.objectionStatus), padding + leftMargin, height);
            doc.text('Application Date:', padding + leftMargin + leftMargin, height);
            doc.text(convertDate(application.creationDate), padding + leftMargin + leftMargin + leftMargin, height);

            var increment = 6;
            var height = height + increment;
            doc.text('Sub-Division: ', padding, height);
            doc.text(subdivisionName(parseInt(applicationId.slice(0, 5))), padding + leftMargin, height);
            doc.text('Connection Type:', padding + leftMargin + leftMargin, height);
            doc.text(application.connectionType, padding + leftMargin + leftMargin + leftMargin, height);

            var increment = 6;
            var height = height + increment;
            doc.text('Phase / Load: ', padding, height);
            doc.text(application.appliedLoad.toString(), padding + leftMargin, height);
            doc.text('Connection Date:', padding + leftMargin + leftMargin, height);
            doc.text('-', padding + leftMargin + leftMargin + leftMargin, height);

            increment = 20;
            height = height + increment
            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 10; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            doc.setFillColor(200, 200, 200);
            // Draw the rectangle
            doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');

            doc.setFont('helvetica', 'bold');
            doc.text('Applicant Particulars', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });

            increment = 6;
            var height = height + increment
            // Get the page width and height

            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 30; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            // Draw the rectangle
            doc.rect(rectX, height - 2.5, rectWidth, rectHeight);

            doc.setFont('helvetica', 'normal');
            increment = 8;
            var height = height + increment
            var leftMargin = 70
            var extraPadding = 5
            doc.text('Applicant Name:', padding + extraPadding, height);
            doc.text(application.applicantName, padding + leftMargin, height);

            increment = 6;
            var height = height + increment
            var leftMargin = 70
            doc.text('CNIC:', padding + extraPadding, height);
            doc.text(application.applicantCNIC, padding + leftMargin, height);

            var height = height + increment
            var leftMargin = 70
            doc.text('Present Address:', padding + extraPadding, height);
            doc.text(application.premisesAddress, padding + leftMargin, height);

            increment = 20;
            height = height + increment
            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 10; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            doc.setFillColor(199, 199, 199);
            // Draw the rectangle
            doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
            doc.setFont('helvetica', 'bold');
            doc.text('Premises Details', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });


            doc.setFontSize(12)
            increment = 3.5;
            var height = height + increment
            // Get the page width and height
            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 18; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            // Draw the rectangle
            doc.rect(rectX, height, rectWidth, rectHeight);

            doc.setFont('helvetica', 'normal');
            increment = 8;
            var height = height + increment
            var leftMargin = 70
            doc.text('No. of meter(s) already installed:', padding + extraPadding, height);
            doc.text(application.noOfMetersAlreadyInstalled.toString(), padding + leftMargin, height);

            increment = 6;
            var height = height + increment
            var leftMargin = 70
            doc.text('Present Address:', padding + extraPadding, height);
            doc.text(application.premisesAddress, padding + leftMargin, height);


            if (copyOfApplicantCNICFront != '' || copyOfApplicantCNICBack != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment
                let copyOfApplicantCNICFrontfileType = copyOfApplicantCNICFront.slice(0, 6)
                let copyOfApplicantCNICBackfileType = copyOfApplicantCNICBack.slice(0, 6)

                let frontExtension = ''
                let backExtension = ''

                console.log(copyOfApplicantCNICFrontfileType, 'printing cnic front file type')
                if (copyOfApplicantCNICFrontfileType == "data:i") {
                    frontExtension = copyOfApplicantCNICFront.slice(11, 15)
                }
                else if (copyOfApplicantCNICFrontfileType == "data:a") {
                    frontExtension = copyOfApplicantCNICFront.slice(17, 19)
                }
                console.log(copyOfApplicantCNICBackfileType, 'printing cnic front file type')
                if (copyOfApplicantCNICBackfileType == "data:i") {
                    backExtension = copyOfApplicantCNICBack.slice(11, 15)
                }
                else if (copyOfApplicantCNICBackfileType == "data:a") {
                    backExtension = copyOfApplicantCNICBack.slice(17, 19)
                }

                console.log(frontExtension, 'printing front extension')
                console.log(backExtension, 'printing back extension')

                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                increment = 10;
                height = height + increment
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text('Applicant CNIC Image', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 200; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 120
                let cardHeight = 80
                var xPos = (pageWidth - cardWidth) / 2;
                if (frontExtension.startsWith('jp')) {
                    doc.addImage(copyOfApplicantCNICFront, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (frontExtension.startsWith('pn')) {
                    doc.addImage(copyOfApplicantCNICFront, 'png', xPos, height, cardWidth, cardHeight);
                }
                else if (frontExtension.startsWith('pd')) {
                    addPdfasImage(copyOfApplicantCNICFront, doc)
                    // doc.addImage(copyOfApplicantCNICFront, 'pdf', xPos, height, cardWidth, cardHeight);
                }

                height = height + 100

                if (backExtension.startsWith('jp')) {
                    doc.addImage(copyOfApplicantCNICBack, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (backExtension.startsWith('pn')) {
                    doc.addImage(copyOfApplicantCNICBack, 'png', xPos, height, cardWidth, cardHeight);
                }
                else if (backExtension.startsWith('pd')) {
                    // doc.addImage(copyOfApplicantCNICBack, 'pdf', xPos, height, cardWidth, cardHeight);
                }
            }

            if (premisesDocument != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = premisesDocument.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text('Property Document', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(premisesDocument, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(premisesDocument, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (scannedCopyOfNearByElectricityBill != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = scannedCopyOfNearByElectricityBill.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text('Near By Bill', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(scannedCopyOfNearByElectricityBill, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(scannedCopyOfNearByElectricityBill, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (copyOfOwnerCNICFront != '' || copyOfOwnerCNICBack != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let frontExtension = copyOfOwnerCNICFront.slice(11, 15)
                let backExtension = copyOfOwnerCNICBack.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text(`Copy of Owner's CNIC`, doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 120
                let cardHeight = 80
                var xPos = (pageWidth - cardWidth) / 2;
                if (frontExtension.startsWith('jp')) {
                    doc.addImage(copyOfOwnerCNICFront, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (frontExtension.startsWith('pn')) {
                    doc.addImage(copyOfOwnerCNICFront, 'png', xPos, height, cardWidth, cardHeight);
                }

                height = height + 100

                if (backExtension.startsWith('jp')) {
                    doc.addImage(copyOfOwnerCNICBack, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (frontExtension.startsWith('pn')) {
                    doc.addImage(copyOfOwnerCNICBack, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (ownerNOC != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = ownerNOC.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text('NOC from Owner', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(ownerNOC, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(ownerNOC, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (resolutionFormDesc != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = resolutionFormDesc.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text(`BODs' Resolution Form`, doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(resolutionFormDesc, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(resolutionFormDesc, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (certMemoDesc != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = certMemoDesc.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text(`Memorandum of Association`, doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(certMemoDesc, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(certMemoDesc, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (certFormDesc != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = certFormDesc.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text(`Certified Form 29`, doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(certFormDesc, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(certFormDesc, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            const totalPages = doc.internal.getNumberOfPages();

            for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i);
                doc.addImage(getWaterMarkLogo(userCompany), 'PNG', 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
            }
            doc.setFontSize(8);

            // Loop through each page
            for (var i = 1; i <= totalPages; i++) {
                // Set the current page
                doc.setPage(i);

                // Get the page width and height
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();

                // Set the position for the page number
                var pageNumberX = pageWidth - 20; // X-coordinate of the page number
                var pageNumberY = pageHeight - 10; // Y-coordinate of the page number

                // Add the page number
                doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() / 2, pageNumberY, {
                    align: 'center',
                });
            }

            doc.save(applicationId + '- NC Application.pdf')
            doc.autoPrint(); // Automatically print the PDF after saving

        }
        catch (e) {
            console.log("Unable to generate Application PDF! ".concat(e))
            console.log(e)
        }
        setViewBackdrop(false)
    }

    return (
        <>
            {/* Applications Table */}
            <Box className='form-box'>
                <h3 className='page-title'>Opt for Smart Meter</h3>
                <Box className='application-table' >
                    <div className='div-datagrid' >
                        <BasicTable
                            data={optApplicationsToDataGrid}
                            columns={tblColumns}
                            handleRowClick={(params) => handleRowClick(params.applicationId)}
                            sx={tableStyle}
                            rowHeight={37.5}
                            pageSize={18}
                            rowsPerPageOptions={[18, 30, 60]}
                            rowsPageOption={false}
                            getRowStyle={(params) => {
                                return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                            }}
                        />
                    </div>
                </Box>
            </Box>

            {/* Main Popup */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'false'}
                className='main-dialog'
            >
                <DialogTitle className="dialog-title" >
                    <Grid container spacing={1} className='headercontainer'>
                        <Grid item lg={0.5}></Grid>
                        <Grid item lg={11} className='applicationTitleGrid'>
                            <Typography className="applicationTitleText">Opt for Smart Meter Application -
                                <span style={{ color: dialogRowData.applicationProgressId < 10 ? '#C46500' : 'white', backgroundColor: dialogRowData.applicationProgressId < 10 ? 'transparent' : '#55ff5d' }}>

                                    {dialogRowData.applicationProgressId === 0 && ' Application Submission'}
                                    {dialogRowData.applicationProgressId === 1 && ' Document Verification'}
                                    {dialogRowData.applicationProgressId === 2 && ' Due Amount Verification'}
                                    {dialogRowData.applicationProgressId === 3 && ` Owner's Consent`}
                                    {dialogRowData.applicationProgressId === 4 && ` Owner's Consent Verification`}
                                    {dialogRowData.applicationProgressId === 5 && ' Meter Change Order'}
                                    {dialogRowData.applicationProgressId === 6 && ' Meter Installation'}
                                    {dialogRowData.applicationProgressId === 7 && ' Complete'}
                                </span>
                            </Typography>
                        </Grid>
                        <Grid item lg={0.25}>
                            <PrintIcon onClick={() => downloadApplicationPDF(dialogRowData.applicationId)} sx={{ cursor: 'pointer', color: 'white' }} />
                        </Grid>
                        <Grid item lg={0.25} className="closeIcon" >
                            <CloseIcon id="clearPopup" onClick={handleClose} sx={{ color: 'white' }} />
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent sx={{ backgroundColor: 'white' }} >
                    <DialogContentText className="dialog-content">
                        <Grid container spacing={1} className='headercontainer'>
                            <Grid item lg={12} className='status-bar'>
                                <StepProgressBar array={NCStatusBarArray} applicationProgressId={dialogRowData.applicationProgressId} objection={dialogRowData.objectionStatus} openDetailsPopUp={openDetailsPopUp} />
                            </Grid>
                            <Grid item lg={12} className='application-details'>
                                <Grid container className="first-row">

                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Application Id</p><p className='prop-detail'>{dialogRowData.applicationId}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Reference Number</p><p className='prop-detail'>{dialogRowData.refNo}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Applicant Name </p><p className='prop-detail'>{dialogRowData.applicantName}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Applicant CNIC.</p><p className='prop-detail'>{dialogRowData.applicantCNIC}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'> Installment Plan</p><p className='prop-detail'>{dialogRowData.planName}</p>
                                    </Grid>
                                    <Grid item lg={2} className='first-row-item'>
                                        <p className='prop-title'>Subdivison</p><p className='prop-detail'>{subdivisionName(dialogRowData.subDivisionCode)}</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item className='processing-summary'>
                                <p className='title'>Activity Log</p>
                                <hr />
                                {
                                    eFileData && <ProcessingSummaryTable data={tableDataProcessingSummary} columns={tableColumnsProcessingSummary} openDetailsPopUp={openDetailsPopUp} />
                                }
                            </Grid>
                            <Grid item className="action-form">
                                <div className='fields'>
                                    {dialogRowData.applicationProgressId === 0 ?
                                        <>
                                            <h3 className='step-title'>Documents Pending</h3>
                                        </> :
                                        dialogRowData.applicationProgressId === 1 && dialogRowData.objectionStatus === 0 ?
                                            CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Document Verification') ?
                                                <>
                                                    <h3 className='step-title'>Verify Document</h3>
                                                    <Grid className='document-verification-container' container spacing={1} sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '1%', padding: '2%' }} >
                                                        {
                                                            (dialogRowData.copyOfApplicantCNIC) &&
                                                            <Grid item lg={2}>
                                                                <Grid container sx={{ backgroundColor: (dialogRowData.copyOfApplicantCNICFlag) ? getDocumentBackGroundColor(dialogRowData.copyOfApplicantCNICFlag) : getDocumentBackGroundColor(flag_copyOfApplicantCNIC), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                    <Grid item lg={12} className="tittlegrid" >
                                                                        <p className='documentTitle'>Applicant's CNIC.</p>
                                                                    </Grid>
                                                                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                        <div onClick={() => { if (!copyOfApplicantCNICVerifyPopUp) { setCopyOfApplicantCNICVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }} >
                                                                            {
                                                                                dialogRowData.copyOfApplicantCNIC.slice(0, 6) == 'data:i' ?
                                                                                    <Base64Image data={dialogRowData.copyOfApplicantCNIC} width='80' />
                                                                                    :
                                                                                    <Base64Image data={pdfIcon} width='40' />
                                                                            }
                                                                            <Base64Image data={dialogRowData.copyOfApplicantCNIC.slice(5, 6) == 'ima' ? dialogRowData.copyOfApplicantCNIC : pdfIcon} width='80' height='50' />
                                                                            {
                                                                                copyOfApplicantCNICVerifyPopUp &&
                                                                                <OpenBase64ImageInPopup
                                                                                    docVerifyPopUp={copyOfApplicantCNICVerifyPopUp}
                                                                                    hideDocVerifyPopup={hideCopyOfApplicantCNICVerifyAlert}
                                                                                    documentName="Applicant CNIC"
                                                                                    documentImage={dialogRowData.copyOfApplicantCNIC}
                                                                                    backDocumentImage={dialogRowData.copyOfApplicantCNIC}
                                                                                    width={'100%'}
                                                                                    document={dialogRowData.copyOfApplicantCNIC}
                                                                                    documentFlag={dialogRowData.copyOfApplicantCNICFlag}
                                                                                    applicationProgressId={dialogRowData.applicationProgressId}
                                                                                    objectionStatus={dialogRowData.objectionStatus}
                                                                                    updateDocFlag={updateDocFlag}
                                                                                    titleToUpdateFlag="copyOfApplicantCNIC"
                                                                                    flag_document={flag_copyOfApplicantCNIC}
                                                                                // flag_documentBack={flag_copyOfApplicantCNICBack}
                                                                                />
                                                                            }
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        }
                                                        {
                                                            dialogRowData.applicantLastPaidBill &&
                                                            <Grid item lg={2}>
                                                                <Grid container sx={{ backgroundColor: dialogRowData.applicantLastPaidBillFlag ? getDocumentBackGroundColor(dialogRowData.applicantLastPaidBillFlag) : getDocumentBackGroundColor(flag_applicantLastPaidBill), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                    <Grid item lg={12} className="tittlegrid" >
                                                                        <p className='documentTitle'>Property Documents</p>
                                                                    </Grid>
                                                                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                        <div onClick={() => { if (!propertyDocVerifyPopUp) { setPropertyDocVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                            {
                                                                                dialogRowData.applicantLastPaidBill.slice(0, 6) == 'data:i' ?
                                                                                    <Base64Image data={dialogRowData.applicantLastPaidBill} width='80' />
                                                                                    :
                                                                                    <Base64Image data={pdfIcon} width='40' />
                                                                            }
                                                                            {
                                                                                propertyDocVerifyPopUp &&
                                                                                <OpenBase64ImageInPopup
                                                                                    docVerifyPopUp={propertyDocVerifyPopUp}
                                                                                    hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                                                                                    documentName="Last Paid Bill"
                                                                                    documentImage={dialogRowData.applicantLastPaidBill}
                                                                                    width={'100%'}
                                                                                    document={dialogRowData.applicantLastPaidBill}
                                                                                    documentFlag={dialogRowData.applicantLastPaidBillFlag}
                                                                                    applicationProgressId={dialogRowData.applicationProgressId}
                                                                                    objectionStatus={dialogRowData.objectionStatus}
                                                                                    updateDocFlag={updateDocFlag}
                                                                                    titleToUpdateFlag="applicantLastPaidBill"
                                                                                    flag_document={flag_applicantLastPaidBill}
                                                                                />
                                                                            }
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                </>
                                                :
                                                <>
                                                    <h3 className='step-title'>Document Verification</h3>
                                                    <p className='group-description'>Document verification is in process by the SDO of subdivision: {subdivisionName(dialogRowData.subDivisionCode)}.</p>
                                                </>
                                            :
                                            dialogRowData.applicationProgressId === 1 && dialogRowData.objectionStatus === 1 ?
                                                <>
                                                    <h3 className='step-title'>Document Objection</h3>
                                                    {
                                                        CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Document Verification') ?
                                                            <p className='group-description'>The CNIC attached in application has objection. In case the CNIC is correct, remove objection by clicking the below button.</p> :
                                                            <p className='group-description'>The CNIC attached in application has objections.</p>
                                                    }
                                                </> :
                                                dialogRowData.applicationProgressId === 2 && dialogRowData.objectionStatus === 0 ?
                                                    CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Due Amount Verification') ?
                                                        <>
                                                            <h3 className='step-title'>Verify Due Amount</h3>
                                                        </>
                                                        :
                                                        <>
                                                            <h3 className='step-title'>Due Amount Verification</h3>
                                                            <p className='group-description'>Due Amount verification is in process by the SDO of subdivision: {subdivisionName(dialogRowData.subDivisionCode)}. </p>
                                                        </>
                                                    :
                                                    dialogRowData.applicationProgressId === 2 && dialogRowData.objectionStatus === 1 ?
                                                        <>
                                                            <h3 className='step-title'>Due Amount Objection</h3>
                                                            {
                                                                CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Due Amount Verification') ?
                                                                    <p className='group-description'>The reference number has pending unpaid dues. In case the consumer has paid the dues, remove objection by clicking below button.</p> :
                                                                    <p className='group-description'>The reference number has pending unpaid dues. </p>
                                                            }
                                                        </> :
                                                        dialogRowData.applicationProgressId === 3 && dialogRowData.objectionStatus === 0 ?
                                                            <>
                                                                <div className='step-title' style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1%', padding: '0.5%' }}>
                                                                    <p style={{ textAlign: 'center', width: '35%', marginTop: '0.5%' }} ></p>
                                                                    <h4 style={{ textAlign: 'center', width: '30%', marginTop: '0.5%' }} >Owner's consent</h4>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', width: '35%', gap: '2%', justifyContent: 'flex-end' }}>
                                                                        <Grid item >
                                                                            <Link to={cfpBaseUrl + 'ConsumerConsent/ConsumerConsentToOptForSmartMeter(NewConsumer).pdf'} target='_blank' style={{ textDecoration: 'none' }}>
                                                                                <Button variant="outlined" size='small' sx={{ backgroundColor: 'white' }} startIcon={<PrintIcon />}  >
                                                                                    New Consumer
                                                                                </Button>
                                                                            </Link>
                                                                        </Grid>
                                                                        <Grid item >
                                                                            <Link to={cfpBaseUrl + 'ConsumerConsent/ConsumerConsentToOptForSmartMeter(ExistingConsumer).pdf'} target='_blank' style={{ textDecoration: 'none' }}>
                                                                                <Button variant="outlined" size='small' sx={{ backgroundColor: 'white' }} startIcon={<PrintIcon />} >
                                                                                    Existing Consumer
                                                                                </Button>
                                                                            </Link>
                                                                        </Grid>
                                                                    </Box>
                                                                </div>
                                                                {
                                                                    (CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Owner Consent') ||
                                                                        CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Owner Consent')) &&
                                                                    <>
                                                                        {
                                                                            consentDetails.consumerConsentFillFlag != 1 &&
                                                                            <Grid container className='field-survey-container'>
                                                                                <Grid item lg={12}>
                                                                                    <Typography className='fieldLabel' >Does the property owner submitted signed consent to opt for smart meter?</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={12}>
                                                                                    <FormControl>
                                                                                        <RadioGroup
                                                                                            defaultValue={fieldFormik.values.iv_consent_submitted}
                                                                                            value={fieldFormik.values.iv_consent_submitted}
                                                                                            name="iv_consent_submitted"
                                                                                            onChange={fieldFormik.handleChange}
                                                                                            row
                                                                                        >
                                                                                            <FormControlLabel value={1} control={<Radio />} label="Yes" />
                                                                                            <FormControlLabel value={0} control={<Radio />} label="No" />
                                                                                        </RadioGroup>
                                                                                    </FormControl>
                                                                                    <Box className='form-error'>
                                                                                        {fieldFormik.errors.iv_consent_submitted && fieldFormik.touched.iv_consent_submitted ? (fieldFormik.errors.iv_consent_submitted) : null}
                                                                                    </Box>
                                                                                </Grid>
                                                                                <Grid item lg={6}>
                                                                                    <Typography className='fieldLabel' >Signed Consent</Typography>
                                                                                    <Box className='documentError'> {fieldFormik.errors.iv_consent_image ? (fieldFormik.errors.iv_consent_image) : null}</Box>
                                                                                    {
                                                                                        consentImageThumbnail ?
                                                                                            <>
                                                                                                <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setConsentImage('') }} />}  >
                                                                                                    {consentImageThumbnail && <img src={consentImageThumbnail} alt='Consent Image' width="100" />}
                                                                                                </Button>
                                                                                            </>
                                                                                            :
                                                                                            <>
                                                                                                <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                                                                    Upload
                                                                                                    <input hidden accept={documentExtensions} id='iv_consent_image' name='iv_consent_image' type="file" onChange={ConsentImage} />
                                                                                                </Button>
                                                                                            </>
                                                                                    }
                                                                                </Grid>
                                                                            </Grid>
                                                                        }
                                                                    </>
                                                                }
                                                            </> :
                                                            dialogRowData.applicationProgressId === 3 && dialogRowData.objectionStatus === 1 ?
                                                                <>
                                                                    <h3 className='step-title'>Site Objection</h3>
                                                                    {
                                                                        CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Owner Consent') ?
                                                                            <p className='group-description'>The propery from which meter has been applied has objection. In case the issue is resolved, remove objection by clicking below button. </p> :
                                                                            <p className='group-description'>The propery from which meter has been applied has objection raised by field staff. </p>
                                                                    }
                                                                </> :
                                                                dialogRowData.applicationProgressId === 4 && dialogRowData.objectionStatus === 0 ?
                                                                    <>
                                                                        {
                                                                            (CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Owner Consent', 'Filled Consent Approval') ||
                                                                                CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Owner Consent', 'Filled Consent Approval')) &&
                                                                            <>
                                                                                <h3 className='step-title'>Signed Consent Validation</h3>
                                                                                <Grid container className='field-survey-container'>
                                                                                    <Grid item lg={6}>
                                                                                        <Typography className='fieldLabel'>
                                                                                            Signed Consent
                                                                                        </Typography>
                                                                                        <Box className='documentError'> {fieldFormik.errors.iv_consent_image ? (fieldFormik.errors.iv_consent_image) : null}</Box>
                                                                                        {
                                                                                            consentImageThumbnail ?
                                                                                                <>
                                                                                                    <div onClick={() => { if (!consentImagePopUp) { setConsentImagePopUp(true) } }}>
                                                                                                        {
                                                                                                            isFileNameImage(consentImageThumbnail) ? (
                                                                                                                <div className='btn-div'>
                                                                                                                    <img src={consentImageThumbnail} alt="Concent Image" width="80" />
                                                                                                                </div>
                                                                                                            ) : (
                                                                                                                <span>{isFileNamePdf(consentImageThumbnail) ?
                                                                                                                    <div className='btn-div'>
                                                                                                                        <img src={pdfIcon} alt="PDF" width="80" />
                                                                                                                    </div>
                                                                                                                    : "Other file type"}</span>
                                                                                                            )}
                                                                                                        {
                                                                                                            consentImagePopUp &&
                                                                                                            <OpenBase64ImageInPopup
                                                                                                                docVerifyPopUp={consentImagePopUp}
                                                                                                                hideDocVerifyPopup={hideConsentImagePopUp}
                                                                                                                documentName="Concent Image"
                                                                                                                documentImage={consentImageThumbnail}
                                                                                                                backDocumentImage={''}
                                                                                                                width={'100%'}
                                                                                                                document={consentImageThumbnail}
                                                                                                                documentFlag={''}
                                                                                                                applicationProgressId={''}
                                                                                                                objectionStatus={''}
                                                                                                                updateDocFlag={updateDocFlag}
                                                                                                                titleToUpdateFlag=""
                                                                                                                flag_document={''}
                                                                                                                flag_documentBack={''}
                                                                                                            />
                                                                                                        }
                                                                                                    </div>
                                                                                                    <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                                                                        <p>Change</p>
                                                                                                        <input hidden accept={documentExtensions} id='iv_consent_image' name='iv_consent_image' type="file" onChange={ConsentImage} />
                                                                                                    </Button>
                                                                                                </>
                                                                                                :
                                                                                                consentImageThumbnail ?
                                                                                                    <>
                                                                                                        <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setConsentImage('') }} />}  >
                                                                                                            {consentImageThumbnail && <img src={consentImageThumbnail} alt="Concent Image" width="100" />}
                                                                                                        </Button>
                                                                                                    </>
                                                                                                    :
                                                                                                    <>
                                                                                                        <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                                                                            Upload
                                                                                                            <input hidden accept={documentExtensions} id='iv_consent_image' name='iv_consent_image' type="file" onChange={ConsentImage} />
                                                                                                        </Button>
                                                                                                    </>
                                                                                        }

                                                                                    </Grid>
                                                                                </Grid>
                                                                            </>
                                                                        }
                                                                        {
                                                                            consentImageThumbnail &&
                                                                            <OpenBase64ImageInPopup
                                                                                docVerifyPopUp={propertyDocVerifyPopUp}
                                                                                hideDocVerifyPopup={consentImage}
                                                                                documentName="Owner Consent Image"
                                                                                documentImage={dialogRowData.applicantLastPaidBill}
                                                                                width={'100%'}
                                                                                document={dialogRowData.applicantLastPaidBill}
                                                                                documentFlag={dialogRowData.applicantLastPaidBillFlag}
                                                                                applicationProgressId={dialogRowData.applicationProgressId}
                                                                                objectionStatus={dialogRowData.objectionStatus}
                                                                                updateDocFlag={updateDocFlag}
                                                                                titleToUpdateFlag="applicantLastPaidBill"
                                                                                flag_document={flag_applicantLastPaidBill}
                                                                            />
                                                                        }
                                                                    </> :
                                                                    dialogRowData.applicationProgressId === 4 && dialogRowData.objectionStatus === 1 ?
                                                                        <>
                                                                            <h3 className='step-title'>Demand Notice Objection</h3>
                                                                            <p className='group-description'>Unable to generate the demand notice. Please contact the relevant field operations officer. </p>
                                                                        </> :
                                                                        dialogRowData.applicationProgressId === 5 && dialogRowData.objectionStatus === 0 ?
                                                                            <>
                                                                                <div className='step-title' style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1%', padding: '0.5%' }}>
                                                                                    <h4 style={{ textAlign: 'center', width: '100%', marginTop: '0.5%' }} >Meter Change Order</h4>
                                                                                    <Button variant="outlined" onClick={() => downloadMCOPDF(dialogRowData.applicationId)} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', width: '5%' }} ><PrintIcon sx={{ color: '#006ad1', marginLeft: '1%' }} /> MCO</Button>
                                                                                </div>
                                                                                <Grid container className='sco-container'>
                                                                                    <Grid item lg={2.2} className='item'>
                                                                                        <Typography className='title'>MCO No.</Typography>
                                                                                        <Typography className='value'>{mcoDetails.mcoId ? mcoDetails.mcoId : '-'}</Typography>
                                                                                    </Grid>
                                                                                    <Grid item lg={2.6} className='item'>
                                                                                        <Typography className='title'>Created On</Typography>
                                                                                        <Typography className='value'>{mcoDetails.mcoCreationDate ? convertDate(mcoDetails.mcoCreationDate) : '-'}</Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                {
                                                                                    (CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance') ||
                                                                                        CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')) &&
                                                                                        ((mcoDetails.mcoP1FilledFlag === null && mcoDetails.mcoOrderFlag === null && mcoDetails.mcoP2approvedFlag === null)
                                                                                            ||
                                                                                            (mcoDetails.mcoP1FilledFlag === 1 && mcoDetails.mcoOrderFlag === null && mcoDetails.mcoP2approvedFlag === null)) ?
                                                                                        <>
                                                                                            <Grid container spacing={2} className='field-survey-container'>

                                                                                                <Grid item lg={3}>
                                                                                                    <Typography className='fieldLabel' >Batch</Typography>
                                                                                                    <Select
                                                                                                        sx={{ width: '100%' }}
                                                                                                        value={mcoPart1Formik.values.iv_batch}
                                                                                                        onChange={mcoPart1Formik.handleChange}
                                                                                                        onBlur={mcoPart1Formik.handleBlur}
                                                                                                        displayEmpty
                                                                                                        disabled={mcoDetails.mcoP1FilledFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                        className='fieldBatch'
                                                                                                        name="iv_batch"
                                                                                                        id="iv_batch"
                                                                                                        MenuProps={{
                                                                                                            PaperProps: {
                                                                                                                style: {
                                                                                                                    width: 20,
                                                                                                                    height: 180
                                                                                                                }
                                                                                                            }
                                                                                                        }}
                                                                                                    >
                                                                                                        <MenuItem value='' sx={{ fontSize: '12px' }}>Select Batch</MenuItem>
                                                                                                        {
                                                                                                            batchArray.map(option => <MenuItem key={option} value={option} sx={{ fontSize: '12px' }}>{option}</MenuItem>)
                                                                                                        }
                                                                                                    </Select>
                                                                                                    <p className='form-error'>
                                                                                                        {mcoPart1Formik.errors.iv_batch && mcoPart1Formik.touched.iv_batch ? (mcoPart1Formik.errors.iv_batch) : null}
                                                                                                    </p>
                                                                                                </Grid>
                                                                                                <Grid item lg={3}>
                                                                                                    <Typography className='fieldLabel' >Memo Number</Typography>
                                                                                                    <TextField
                                                                                                        required
                                                                                                        type='number'
                                                                                                        InputProps={{
                                                                                                            inputProps: { min: 0 }
                                                                                                        }}
                                                                                                        disabled={mcoDetails.mcoP1FilledFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                        autoComplete='off'
                                                                                                        name="iv_memo_number"
                                                                                                        value={mcoPart1Formik.values.iv_memo_number}
                                                                                                        onChange={mcoPart1Formik.handleChange}
                                                                                                        onBlur={mcoPart1Formik.handleBlur}
                                                                                                        id="iv_memo_number"
                                                                                                        className='fieldCoverageMarla'
                                                                                                    />
                                                                                                    <p className='form-error'>
                                                                                                        {mcoPart1Formik.errors.iv_memo_number && mcoPart1Formik.touched.iv_memo_number ? (mcoPart1Formik.errors.iv_memo_number) : null}
                                                                                                    </p>
                                                                                                </Grid>
                                                                                                <Grid item lg={3}>
                                                                                                    <Typography className='fieldLabel' >Memo Date</Typography>
                                                                                                    <input
                                                                                                        name="iv_memo_date"
                                                                                                        disabled={mcoDetails.mcoP1FilledFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                        value={mcoPart1Formik.values.iv_memo_date}
                                                                                                        onChange={mcoPart1Formik.handleChange}
                                                                                                        onBlur={mcoPart1Formik.handleBlur}
                                                                                                        type='date'
                                                                                                        className='fieldReferenceNo'
                                                                                                        style={{ width: '100%', height: '30px', borderWidth: '1px', borderRadius: '3px', borderColor: 'lightgrey' }}
                                                                                                        min={dialogRowData.creationDate.slice(0, 10)}
                                                                                                        max={new Date().toISOString().split('T')[0]}
                                                                                                    />
                                                                                                    <p className='form-error'>
                                                                                                        {mcoPart1Formik.errors.iv_memo_date && mcoPart1Formik.touched.iv_memo_date ? (mcoPart1Formik.errors.iv_memo_date) : null}
                                                                                                    </p>
                                                                                                </Grid>
                                                                                                {
                                                                                                    dialogRowData.mntVerificationFlag === 1 &&
                                                                                                    <>
                                                                                                        <Grid item lg={3}>
                                                                                                            <Typography className='fieldLabel' >M & T Number</Typography>
                                                                                                            <TextField
                                                                                                                required
                                                                                                                type='number'
                                                                                                                InputProps={{
                                                                                                                    inputProps: { min: 0 }
                                                                                                                }}
                                                                                                                disabled={mcoDetails.mcoP1FilledFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                autoComplete='off'
                                                                                                                name="iv_mt_number"
                                                                                                                value={mcoPart1Formik.values.iv_mt_number}
                                                                                                                onChange={mcoPart1Formik.handleChange}
                                                                                                                onBlur={mcoPart1Formik.handleBlur}
                                                                                                                id="iv_mt_number"
                                                                                                                className='fieldCoverageMarla'
                                                                                                            />
                                                                                                            <p className='form-error'>
                                                                                                                {mcoPart1Formik.errors.iv_mt_number && mcoPart1Formik.touched.iv_mt_number ? (mcoPart1Formik.errors.iv_mt_number) : null}
                                                                                                            </p>
                                                                                                        </Grid>
                                                                                                        <Grid item lg={3}>
                                                                                                            <Typography className='fieldLabel' >M & T Date</Typography>
                                                                                                            <input
                                                                                                                name="iv_mt_date"
                                                                                                                disabled={mcoDetails.mcoP1FilledFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                value={mcoPart1Formik.values.iv_mt_date}
                                                                                                                onChange={mcoPart1Formik.handleChange}
                                                                                                                onBlur={mcoPart1Formik.handleBlur}
                                                                                                                type='date'
                                                                                                                className='fieldReferenceNo'
                                                                                                                style={{ width: '100%', height: '30px', borderWidth: '1px', borderRadius: '3px', borderColor: 'lightgrey' }}
                                                                                                                min={dialogRowData.creationDate.slice(0, 10)}
                                                                                                                max={new Date().toISOString().split('T')[0]}
                                                                                                            />
                                                                                                            <p className='form-error'>
                                                                                                                {mcoPart1Formik.errors.iv_mt_date && mcoPart1Formik.touched.iv_mt_date ? (mcoPart1Formik.errors.iv_mt_date) : null}
                                                                                                            </p>
                                                                                                        </Grid>
                                                                                                    </>
                                                                                                }
                                                                                            </Grid>
                                                                                            {/* <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '14px', color: 'black' }}>Area Information</Typography> */}
                                                                                        </> : null
                                                                                }
                                                                            </> :
                                                                            dialogRowData.applicationProgressId === 5 && dialogRowData.objectionStatus === 1 ?
                                                                                <>
                                                                                    <h3 className='step-title'>Demand Notice Payment Objection</h3>
                                                                                </> :
                                                                                dialogRowData.applicationProgressId === 6 && dialogRowData.objectionStatus === 0 ?
                                                                                    <>
                                                                                        <div className='step-title' style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1%', padding: '0.5%' }}>
                                                                                            <h4 style={{ textAlign: 'center', width: '100%', marginTop: '0.5%' }} >Meter Change Order</h4>
                                                                                            <Button variant="outlined" onClick={() => downloadMCOPDF(dialogRowData.applicationId)} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', width: '5%' }} ><PrintIcon sx={{ color: '#006ad1', marginLeft: '1%' }} /> MCO</Button>
                                                                                        </div>
                                                                                        <Grid container className='sco-container'>
                                                                                            <Grid item lg={2.2} className='item'>
                                                                                                <Typography className='title'>MCO No.</Typography>
                                                                                                <Typography className='value'>{mcoDetails.mcoId ? mcoDetails.mcoId : '-'}</Typography>
                                                                                            </Grid>
                                                                                            <Grid item lg={2.6} className='item'>
                                                                                                <Typography className='title'>Issued On</Typography>
                                                                                                <Typography className='value'>{mcoDetails.mcoOrderedDate ? convertDate(mcoDetails.mcoCreationDate) : '-'}</Typography>
                                                                                            </Grid>

                                                                                        </Grid>
                                                                                        {
                                                                                            (CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance') ||
                                                                                                CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')) && (
                                                                                                    (mcoDetails.mcoP1FilledFlag === 1 && mcoDetails.mcoOrderFlag === 1 && mcoDetails.complianceFlag === null && mcoDetails.mcoP2approvedFlag === null)
                                                                                                    ||
                                                                                                    (mcoDetails.mcoP1FilledFlag === 1 && mcoDetails.mcoOrderFlag === 1 && mcoDetails.complianceFlag === 1 && mcoDetails.mcoP2approvedFlag === null)) ?
                                                                                                <>
                                                                                                    <Grid container className='field-survey-container'>

                                                                                                        <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '14px', color: 'black' }}>Meter Removed</Typography>
                                                                                                        <Grid container spacing={2}>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Meter Serial No.</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_removed_Meter_No"
                                                                                                                    value={mcoPart2Formik.values.iv_removed_Meter_No}
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    inputProps={{ maxLength: 10 }}
                                                                                                                    type='text'
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_removed_Meter_No && mcoPart2Formik.touched.iv_removed_Meter_No ? (mcoPart2Formik.errors.iv_removed_Meter_No) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Manuf. Code</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_removed_Mnfg_Code"
                                                                                                                    defaultValue={mcoPart2Formik.values.iv_removed_Meter_No ? mcoPart2Formik.values.iv_removed_Meter_No.slice(0, 2) : ''}
                                                                                                                    value={mcoPart2Formik.values.iv_removed_Meter_No ? mcoPart2Formik.values.iv_removed_Meter_No.slice(0, 2) : ''}
                                                                                                                    type='number'
                                                                                                                    fullWidth
                                                                                                                    disabled
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_removed_Mnfg_Code && mcoPart2Formik.touched.iv_removed_Mnfg_Code ? (mcoPart2Formik.errors.iv_removed_Mnfg_Code) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Multiplying Factor</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_removed_Meter_MF"
                                                                                                                    value={mcoPart2Formik.values.iv_removed_Meter_MF}
                                                                                                                    type='number'
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    InputProps={{
                                                                                                                        inputProps: { min: 1 }
                                                                                                                    }}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_removed_Meter_MF && mcoPart2Formik.touched.iv_removed_Meter_MF ? (mcoPart2Formik.errors.iv_removed_Meter_MF) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Meter Range</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_removed_Meter_Range"
                                                                                                                    value={mcoPart2Formik.values.iv_removed_Meter_Range}
                                                                                                                    type='text'
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_removed_Meter_Range && mcoPart2Formik.touched.iv_removed_Meter_Range ? (mcoPart2Formik.errors.iv_removed_Meter_Range) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >kWh {(dialogRowData.meterPhase === "3-Phase" || dialogRowData.meterPhase === "THREE-Phase") && 'Peak'}</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_removed_Meter_KWH_Peak"
                                                                                                                    value={mcoPart2Formik.values.iv_removed_Meter_KWH_Peak}
                                                                                                                    type='number'
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    fullWidth
                                                                                                                    InputProps={{
                                                                                                                        inputProps: { min: 0 }
                                                                                                                    }}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_removed_Meter_KWH_Peak && mcoPart2Formik.touched.iv_removed_Meter_KWH_Peak ? (mcoPart2Formik.errors.iv_removed_Meter_KWH_Peak) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            {
                                                                                                                (dialogRowData.meterPhase === "3-Phase" || dialogRowData.meterPhase === "THREE-Phase") &&
                                                                                                                <>
                                                                                                                    <Grid item lg={2}>
                                                                                                                        <Typography className='fieldLabel' >kWh OffPeak</Typography>
                                                                                                                        <TextField
                                                                                                                            name="iv_removed_Meter_KWH_OffPeak"
                                                                                                                            value={mcoPart2Formik.values.iv_removed_Meter_KWH_OffPeak}
                                                                                                                            type='number'
                                                                                                                            disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                            fullWidth
                                                                                                                            InputProps={{
                                                                                                                                inputProps: { min: 0 }
                                                                                                                            }}
                                                                                                                            onChange={mcoPart2Formik.handleChange}
                                                                                                                            onBlur={mcoPart2Formik.handleBlur}
                                                                                                                            className='fieldCoverageMarla'
                                                                                                                        />
                                                                                                                        <p className='form-error'>
                                                                                                                            {mcoPart2Formik.errors.iv_removed_Meter_KWH_OffPeak && mcoPart2Formik.touched.iv_removed_Meter_KWH_OffPeak ? (mcoPart2Formik.errors.iv_removed_Meter_KWH_OffPeak) : null}
                                                                                                                        </p>
                                                                                                                    </Grid>
                                                                                                                    <Grid item lg={2}>
                                                                                                                        <Typography className='fieldLabel' >kVarh Peak</Typography>
                                                                                                                        <TextField
                                                                                                                            name="iv_removed_Meter_KVARH_Peak"
                                                                                                                            value={mcoPart2Formik.values.iv_removed_Meter_KVARH_Peak}
                                                                                                                            type='number'
                                                                                                                            disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                            fullWidth
                                                                                                                            InputProps={{
                                                                                                                                inputProps: { min: 0 }
                                                                                                                            }}
                                                                                                                            onChange={mcoPart2Formik.handleChange}
                                                                                                                            onBlur={mcoPart2Formik.handleBlur}
                                                                                                                            className='fieldCoverageMarla'
                                                                                                                        />
                                                                                                                        <p className='form-error'>
                                                                                                                            {mcoPart2Formik.errors.iv_removed_Meter_KVARH_Peak && mcoPart2Formik.touched.iv_removed_Meter_KVARH_Peak ? (mcoPart2Formik.errors.iv_removed_Meter_KVARH_Peak) : null}
                                                                                                                        </p>
                                                                                                                    </Grid>
                                                                                                                    <Grid item lg={2}>
                                                                                                                        <Typography className='fieldLabel' >kVarh OffPeak</Typography>
                                                                                                                        <TextField
                                                                                                                            name="iv_removed_Meter_KVARH_OffPeak"
                                                                                                                            value={mcoPart2Formik.values.iv_removed_Meter_KVARH_OffPeak}
                                                                                                                            type='number'
                                                                                                                            disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                            fullWidth
                                                                                                                            InputProps={{
                                                                                                                                inputProps: { min: 0 }
                                                                                                                            }}
                                                                                                                            onChange={mcoPart2Formik.handleChange}
                                                                                                                            onBlur={mcoPart2Formik.handleBlur}
                                                                                                                            className='fieldCoverageMarla'
                                                                                                                        />
                                                                                                                        <p className='form-error'>
                                                                                                                            {mcoPart2Formik.errors.iv_removed_Meter_KVARH_OffPeak && mcoPart2Formik.touched.iv_removed_Meter_KVARH_OffPeak ? (mcoPart2Formik.errors.iv_removed_Meter_KVARH_OffPeak) : null}
                                                                                                                        </p>
                                                                                                                    </Grid>
                                                                                                                    <Grid item lg={2}>
                                                                                                                        <Typography className='fieldLabel' >MDI Peak</Typography>
                                                                                                                        <TextField
                                                                                                                            name="iv_removed_Meter_MDI_SUMPeak"
                                                                                                                            value={mcoPart2Formik.values.iv_removed_Meter_MDI_SUMPeak}
                                                                                                                            type='number'
                                                                                                                            disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                            fullWidth
                                                                                                                            InputProps={{
                                                                                                                                inputProps: { min: 0 }
                                                                                                                            }}
                                                                                                                            onChange={mcoPart2Formik.handleChange}
                                                                                                                            onBlur={mcoPart2Formik.handleBlur}
                                                                                                                            className='fieldCoverageMarla'
                                                                                                                        />
                                                                                                                        <p className='form-error'>
                                                                                                                            {mcoPart2Formik.errors.iv_removed_Meter_MDI_SUMPeak && mcoPart2Formik.touched.iv_removed_Meter_MDI_SUMPeak ? (mcoPart2Formik.errors.iv_removed_Meter_MDI_SUMPeak) : null}
                                                                                                                        </p>
                                                                                                                    </Grid>
                                                                                                                    <Grid item lg={2}>
                                                                                                                        <Typography className='fieldLabel' >MDI OffPeak</Typography>
                                                                                                                        <TextField
                                                                                                                            name="iv_removed_Meter_MDI_SUMOffPeak"
                                                                                                                            value={mcoPart2Formik.values.iv_removed_Meter_MDI_SUMOffPeak}
                                                                                                                            type='number'
                                                                                                                            disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                            fullWidth
                                                                                                                            InputProps={{
                                                                                                                                inputProps: { min: 0 }
                                                                                                                            }}
                                                                                                                            onChange={mcoPart2Formik.handleChange}
                                                                                                                            onBlur={mcoPart2Formik.handleBlur}
                                                                                                                            className='fieldCoverageMarla'
                                                                                                                        />
                                                                                                                        <p className='form-error'>
                                                                                                                            {mcoPart2Formik.errors.iv_removed_Meter_MDI_SUMOffPeak && mcoPart2Formik.touched.iv_removed_Meter_MDI_SUMOffPeak ? (mcoPart2Formik.errors.iv_removed_Meter_MDI_SUMOffPeak) : null}
                                                                                                                        </p>
                                                                                                                    </Grid>
                                                                                                                </>
                                                                                                            }
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Meter Image</Typography>
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_removed_Meter_Image && mcoPart2Formik.touched.iv_removed_Meter_Image ? (mcoPart2Formik.errors.iv_removed_Meter_Image) : null}
                                                                                                                </p>
                                                                                                                {
                                                                                                                    removedMeterImageThumbnail ?
                                                                                                                        <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />} disabled={(2 === 1 && CheckPermissions('Billing and Collection', 'Meter Change Request', 'Workflow Permissions', 'Meter and Site Report Approval'))} >
                                                                                                                            {removedMeterImageThumbnail && isFileNameImage(removedMeterImageThumbnail) ? (
                                                                                                                                <div className='btn-div'>
                                                                                                                                    <img src={removedMeterImageThumbnail} alt="Removed Meter" width="80" />
                                                                                                                                    <p>{removedMeterImageFileName}</p>
                                                                                                                                </div>
                                                                                                                            ) : (
                                                                                                                                <span>{isFileNamePdf(removedMeterImageThumbnail) ?
                                                                                                                                    <div className='btn-div'>
                                                                                                                                        <img src={pdfIcon} alt="PDF" width="80" />
                                                                                                                                        <p>{removedMeterImageFileName}</p>
                                                                                                                                    </div>
                                                                                                                                    : "Other file type"}</span>
                                                                                                                            )}
                                                                                                                            <input hidden accept={documentExtensions} id='iv_removed_Meter_Image' name='iv_removed_Meter_Image' type="file" onChange={RemovedMeterImage} />
                                                                                                                        </Button>
                                                                                                                        :
                                                                                                                        removedMeterImageThumbnail ?
                                                                                                                            <>
                                                                                                                                <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setRemovedMeterImage('') }} />}  >
                                                                                                                                    {removedMeterImageThumbnail && <img src={removedMeterImageThumbnail} alt="Removed Meter" width="100" />}
                                                                                                                                </Button>
                                                                                                                            </>
                                                                                                                            :
                                                                                                                            <>
                                                                                                                                <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                                                                                                    Upload
                                                                                                                                    <input hidden accept={documentExtensions} id='iv_removed_Meter_Image' name='iv_removed_Meter_Image' type="file" onChange={RemovedMeterImage} />
                                                                                                                                </Button>
                                                                                                                            </>
                                                                                                                }
                                                                                                            </Grid>
                                                                                                            {
                                                                                                                (dialogRowData.meterPhase === "3-Phase" || dialogRowData.meterPhase === "THREE-Phase") &&
                                                                                                                <Grid item lg={2}>
                                                                                                                    <Typography className='fieldLabel' >Reset No.</Typography>
                                                                                                                    <TextField
                                                                                                                        name="iv_reset_No"
                                                                                                                        value={mcoPart2Formik.values.iv_reset_No}
                                                                                                                        type='number'
                                                                                                                        disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                        fullWidth
                                                                                                                        InputProps={{
                                                                                                                            inputProps: { min: 0 }
                                                                                                                        }}
                                                                                                                        onChange={mcoPart2Formik.handleChange}
                                                                                                                        onBlur={mcoPart2Formik.handleBlur}
                                                                                                                        className='fieldCoverageMarla'
                                                                                                                    />
                                                                                                                    <p className='form-error'>
                                                                                                                        {mcoPart2Formik.errors.iv_reset_No && mcoPart2Formik.touched.iv_reset_No ? (mcoPart2Formik.errors.iv_reset_No) : null}
                                                                                                                    </p>
                                                                                                                </Grid>
                                                                                                            }
                                                                                                        </Grid>
                                                                                                        <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '14px', color: 'black' }}>Installed Removed</Typography>
                                                                                                        <Grid container spacing={2} >
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Meter Serial No.</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_installed_Meter_No"
                                                                                                                    value={mcoPart2Formik.values.iv_installed_Meter_No}
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    inputProps={{ maxLength: 10 }}
                                                                                                                    type='text'
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_installed_Meter_No && mcoPart2Formik.touched.iv_installed_Meter_No ? (mcoPart2Formik.errors.iv_installed_Meter_No) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Manuf. Code</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_installed_Mnfg_Code"
                                                                                                                    defaultValue={mcoPart2Formik.values.iv_installed_Meter_No ? mcoPart2Formik.values.iv_installed_Meter_No.slice(0, 2) : ''}
                                                                                                                    value={mcoPart2Formik.values.iv_installed_Meter_No ? mcoPart2Formik.values.iv_installed_Meter_No.slice(0, 2) : ''}
                                                                                                                    type='text'
                                                                                                                    fullWidth
                                                                                                                    disabled
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_installed_Mnfg_Code && mcoPart2Formik.touched.iv_installed_Mnfg_Code ? (mcoPart2Formik.errors.iv_installed_Mnfg_Code) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Multiplying Factor</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_installed_Meter_MF"
                                                                                                                    value={mcoPart2Formik.values.iv_installed_Meter_MF}
                                                                                                                    type='number'
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    InputProps={{
                                                                                                                        inputProps: { min: 1 }
                                                                                                                    }}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_installed_Meter_MF && mcoPart2Formik.touched.iv_installed_Meter_MF ? (mcoPart2Formik.errors.iv_installed_Meter_MF) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Meter Range</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_installed_Meter_Range"
                                                                                                                    value={mcoPart2Formik.values.iv_installed_Meter_Range}
                                                                                                                    type='text'
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_installed_Meter_Range && mcoPart2Formik.touched.iv_installed_Meter_Range ? (mcoPart2Formik.errors.iv_installed_Meter_Range) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >kWh {(dialogRowData.meterPhase === "3-Phase" || dialogRowData.meterPhase === "THREE-Phase") && 'Peak'}</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_installed_Meter_KWH_Peak"
                                                                                                                    value={mcoPart2Formik.values.iv_installed_Meter_KWH_Peak}
                                                                                                                    type='number'
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    fullWidth
                                                                                                                    InputProps={{
                                                                                                                        inputProps: { min: 0 }
                                                                                                                    }}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_installed_Meter_KWH_Peak && mcoPart2Formik.touched.iv_installed_Meter_KWH_Peak ? (mcoPart2Formik.errors.iv_installed_Meter_KWH_Peak) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            {
                                                                                                                (dialogRowData.meterPhase === "3-Phase" || dialogRowData.meterPhase === "THREE-Phase") &&
                                                                                                                <>
                                                                                                                    <Grid item lg={2}>
                                                                                                                        <Typography className='fieldLabel' >kWh OffPeak</Typography>
                                                                                                                        <TextField
                                                                                                                            name="iv_installed_Meter_KWH_OffPeak"
                                                                                                                            value={mcoPart2Formik.values.iv_installed_Meter_KWH_OffPeak}
                                                                                                                            type='number'
                                                                                                                            disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                            fullWidth
                                                                                                                            InputProps={{
                                                                                                                                inputProps: { min: 0 }
                                                                                                                            }}
                                                                                                                            onChange={mcoPart2Formik.handleChange}
                                                                                                                            onBlur={mcoPart2Formik.handleBlur}
                                                                                                                            className='fieldCoverageMarla'
                                                                                                                        />
                                                                                                                        <p className='form-error'>
                                                                                                                            {mcoPart2Formik.errors.iv_installed_Meter_KWH_OffPeak && mcoPart2Formik.touched.iv_installed_Meter_KWH_OffPeak ? (mcoPart2Formik.errors.iv_installed_Meter_KWH_OffPeak) : null}
                                                                                                                        </p>
                                                                                                                    </Grid>
                                                                                                                    <Grid item lg={2}>
                                                                                                                        <Typography className='fieldLabel' >kVarh Peak</Typography>
                                                                                                                        <TextField
                                                                                                                            name="iv_installed_Meter_KVARH_Peak"
                                                                                                                            value={mcoPart2Formik.values.iv_installed_Meter_KVARH_Peak}
                                                                                                                            type='number'
                                                                                                                            disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                            fullWidth
                                                                                                                            InputProps={{
                                                                                                                                inputProps: { min: 0 }
                                                                                                                            }}
                                                                                                                            onChange={mcoPart2Formik.handleChange}
                                                                                                                            onBlur={mcoPart2Formik.handleBlur}
                                                                                                                            className='fieldCoverageMarla'
                                                                                                                        />
                                                                                                                        <p className='form-error'>
                                                                                                                            {mcoPart2Formik.errors.iv_installed_Meter_KVARH_Peak && mcoPart2Formik.touched.iv_installed_Meter_KVARH_Peak ? (mcoPart2Formik.errors.iv_installed_Meter_KVARH_Peak) : null}
                                                                                                                        </p>
                                                                                                                    </Grid>
                                                                                                                    <Grid item lg={2}>
                                                                                                                        <Typography className='fieldLabel' >kVarh OffPeak</Typography>
                                                                                                                        <TextField
                                                                                                                            name="iv_installed_Meter_KVARH_OffPeak"
                                                                                                                            value={mcoPart2Formik.values.iv_installed_Meter_KVARH_OffPeak}
                                                                                                                            type='number'
                                                                                                                            disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                            fullWidth
                                                                                                                            InputProps={{
                                                                                                                                inputProps: { min: 0 }
                                                                                                                            }}
                                                                                                                            onChange={mcoPart2Formik.handleChange}
                                                                                                                            onBlur={mcoPart2Formik.handleBlur}
                                                                                                                            className='fieldCoverageMarla'
                                                                                                                        />
                                                                                                                        <p className='form-error'>
                                                                                                                            {mcoPart2Formik.errors.iv_installed_Meter_KVARH_OffPeak && mcoPart2Formik.touched.iv_installed_Meter_KVARH_OffPeak ? (mcoPart2Formik.errors.iv_installed_Meter_KVARH_OffPeak) : null}
                                                                                                                        </p>
                                                                                                                    </Grid>
                                                                                                                    <Grid item lg={2}>
                                                                                                                        <Typography className='fieldLabel' >MDI Peak</Typography>
                                                                                                                        <TextField
                                                                                                                            name="iv_installed_Meter_MDI_SUMPeak"
                                                                                                                            value={mcoPart2Formik.values.iv_installed_Meter_MDI_SUMPeak}
                                                                                                                            type='number'
                                                                                                                            disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                            fullWidth
                                                                                                                            InputProps={{
                                                                                                                                inputProps: { min: 0 }
                                                                                                                            }}
                                                                                                                            onChange={mcoPart2Formik.handleChange}
                                                                                                                            onBlur={mcoPart2Formik.handleBlur}
                                                                                                                            className='fieldCoverageMarla'
                                                                                                                        />
                                                                                                                        <p className='form-error'>
                                                                                                                            {mcoPart2Formik.errors.iv_installed_Meter_MDI_SUMPeak && mcoPart2Formik.touched.iv_installed_Meter_MDI_SUMPeak ? (mcoPart2Formik.errors.iv_installed_Meter_MDI_SUMPeak) : null}
                                                                                                                        </p>
                                                                                                                    </Grid>
                                                                                                                    <Grid item lg={2}>
                                                                                                                        <Typography className='fieldLabel' >MDI OffPeak</Typography>
                                                                                                                        <TextField
                                                                                                                            name="iv_installed_Meter_MDI_SUMOffPeak"
                                                                                                                            value={mcoPart2Formik.values.iv_installed_Meter_MDI_SUMOffPeak}
                                                                                                                            type='number'
                                                                                                                            disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                            fullWidth
                                                                                                                            InputProps={{
                                                                                                                                inputProps: { min: 0 }
                                                                                                                            }}
                                                                                                                            onChange={mcoPart2Formik.handleChange}
                                                                                                                            onBlur={mcoPart2Formik.handleBlur}
                                                                                                                            className='fieldCoverageMarla'
                                                                                                                        />
                                                                                                                        <p className='form-error'>
                                                                                                                            {mcoPart2Formik.errors.iv_installed_Meter_MDI_SUMOffPeak && mcoPart2Formik.touched.iv_installed_Meter_MDI_SUMOffPeak ? (mcoPart2Formik.errors.iv_installed_Meter_MDI_SUMOffPeak) : null}
                                                                                                                        </p>
                                                                                                                    </Grid>
                                                                                                                </>
                                                                                                            }
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Meter Image</Typography>
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_installed_Meter_Image && mcoPart2Formik.touched.iv_installed_Meter_Image ? (mcoPart2Formik.errors.iv_installed_Meter_Image) : null}
                                                                                                                </p>
                                                                                                                {
                                                                                                                    installedMeterImageThumbnail ?
                                                                                                                        <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />} disabled={(2 === 1 && CheckPermissions('Billing and Collection', 'Meter Change Request', 'Workflow Permissions', 'Meter and Site Report Approval'))} >
                                                                                                                            {installedMeterImageThumbnail && isFileNameImage(installedMeterImageThumbnail) ? (
                                                                                                                                <div className='btn-div'>
                                                                                                                                    <img src={installedMeterImageThumbnail} alt="Installed Meter" width="80" />
                                                                                                                                    <p>{installedMeterImageFileName}</p>
                                                                                                                                </div>
                                                                                                                            ) : (
                                                                                                                                <span>{isFileNamePdf(installedMeterImageThumbnail) ?
                                                                                                                                    <div className='btn-div'>
                                                                                                                                        <img src={pdfIcon} alt="PDF" width="80" />
                                                                                                                                        <p>{installedMeterImageFileName}</p>
                                                                                                                                    </div>
                                                                                                                                    : "Other file type"}</span>
                                                                                                                            )}
                                                                                                                            <input hidden accept={documentExtensions} id='iv_installed_Meter_Image' name='iv_installed_Meter_Image' type="file" onChange={InstalledMeterImage} />
                                                                                                                        </Button>
                                                                                                                        :
                                                                                                                        installedMeterImageThumbnail ?
                                                                                                                            <>
                                                                                                                                <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setInstalledMeterImage('') }} />}  >
                                                                                                                                    {installedMeterImageThumbnail && <img src={installedMeterImageThumbnail} alt="Installed Meter" width="100" />}
                                                                                                                                </Button>
                                                                                                                            </>
                                                                                                                            :
                                                                                                                            <>
                                                                                                                                <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                                                                                                    Upload
                                                                                                                                    <input hidden accept={documentExtensions} id='iv_installed_meter_image' name='iv_installed_meter_image' type="file" onChange={InstalledMeterImage} />
                                                                                                                                </Button>
                                                                                                                            </>
                                                                                                                }
                                                                                                            </Grid>
                                                                                                            {
                                                                                                                (dialogRowData.meterPhase === "3-Phase" || dialogRowData.meterPhase === "THREE-Phase") &&
                                                                                                                <Grid item lg={2}>
                                                                                                                    <Typography className='fieldLabel' >Reset No.</Typography>
                                                                                                                    <TextField
                                                                                                                        name="iv_installed_Meter_Reset_No"
                                                                                                                        value={mcoPart2Formik.values.iv_installed_Meter_Reset_No}
                                                                                                                        type='number'
                                                                                                                        disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                        fullWidth
                                                                                                                        InputProps={{
                                                                                                                            inputProps: { min: 0 }
                                                                                                                        }}
                                                                                                                        onChange={mcoPart2Formik.handleChange}
                                                                                                                        onBlur={mcoPart2Formik.handleBlur}
                                                                                                                        className='fieldCoverageMarla'
                                                                                                                    />
                                                                                                                    <p className='form-error'>
                                                                                                                        {mcoPart2Formik.errors.iv_installed_Meter_Reset_No && mcoPart2Formik.touched.iv_installed_Meter_Reset_No ? (mcoPart2Formik.errors.iv_installed_Meter_Reset_No) : null}
                                                                                                                    </p>
                                                                                                                </Grid>
                                                                                                            }
                                                                                                        </Grid>
                                                                                                        {
                                                                                                            (dialogRowData.meterPhase === "3-Phase" || dialogRowData.meterPhase === "THREE-Phase") && <>
                                                                                                                <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '14px', color: 'black' }}>Checking Report</Typography>
                                                                                                                <Grid container spacing={2} >
                                                                                                                    <Grid item lg={2}>
                                                                                                                        <Typography className='fieldLabel' >CR No.</Typography>
                                                                                                                        <TextField
                                                                                                                            name="iv_checking_Report_No"
                                                                                                                            value={mcoPart2Formik.values.iv_checking_Report_No}
                                                                                                                            fullWidth
                                                                                                                            disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                            onChange={mcoPart2Formik.handleChange}
                                                                                                                            onBlur={mcoPart2Formik.handleBlur}
                                                                                                                            inputProps={{ maxLength: 10 }}
                                                                                                                            type='text'
                                                                                                                            className='fieldCoverageMarla'
                                                                                                                        />
                                                                                                                        <p className='form-error'>
                                                                                                                            {mcoPart2Formik.errors.iv_checking_Report_No && mcoPart2Formik.touched.iv_checking_Report_No ? (mcoPart2Formik.errors.iv_checking_Report_No) : null}
                                                                                                                        </p>
                                                                                                                    </Grid>
                                                                                                                    <Grid item lg={2}>
                                                                                                                        <Typography className='fieldLabel' >Date</Typography>
                                                                                                                        <input
                                                                                                                            name="iv_checking_Report_Date"
                                                                                                                            disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                            value={mcoPart2Formik.values.iv_checking_Report_Date}
                                                                                                                            onChange={mcoPart2Formik.handleChange}
                                                                                                                            onBlur={mcoPart2Formik.handleBlur}
                                                                                                                            type='date'
                                                                                                                            className='fieldReferenceNo'
                                                                                                                            style={{ width: '100%', height: '30px', borderWidth: '1px', borderRadius: '3px', borderColor: 'lightgrey' }}
                                                                                                                            min={mcoDetails.mcoOrderedDate.slice(0, 10)}
                                                                                                                            max={new Date().toISOString().split('T')[0]}
                                                                                                                        />
                                                                                                                        <p className='form-error'>
                                                                                                                            {mcoPart2Formik.errors.iv_checking_Report_Date && mcoPart2Formik.touched.iv_checking_Report_Date ? (mcoPart2Formik.errors.iv_checking_Report_Date) : null}
                                                                                                                        </p>
                                                                                                                    </Grid>
                                                                                                                </Grid>
                                                                                                            </>
                                                                                                        }
                                                                                                        <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '14px', color: 'black' }}>Store Requisition</Typography>
                                                                                                        <Grid container spacing={2}>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >SR No.</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_store_requisition_no"
                                                                                                                    value={mcoPart2Formik.values.iv_store_requisition_no}
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    inputProps={{ maxLength: 10 }}
                                                                                                                    type='text'
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_store_requisition_no && mcoPart2Formik.touched.iv_store_requisition_no ? (mcoPart2Formik.errors.iv_store_requisition_no) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Store Req. Date</Typography>
                                                                                                                <input
                                                                                                                    name="iv_store_requisition_date"
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    value={mcoPart2Formik.values.iv_store_requisition_date}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    type='date'
                                                                                                                    className='fieldReferenceNo'
                                                                                                                    style={{ width: '100%', height: '30px', borderWidth: '1px', borderRadius: '3px', borderColor: 'lightgrey' }}
                                                                                                                    min={mcoDetails.mcoOrderedDate.slice(0, 10)}
                                                                                                                    max={new Date().toISOString().split('T')[0]}
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_store_requisition_date && mcoPart2Formik.touched.iv_store_requisition_date ? (mcoPart2Formik.errors.iv_store_requisition_date) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Cp-78 Item No.</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_cp_Form_78"
                                                                                                                    value={mcoPart2Formik.values.iv_cp_Form_78}
                                                                                                                    type='text'
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_cp_Form_78 && mcoPart2Formik.touched.iv_cp_Form_78 ? (mcoPart2Formik.errors.iv_cp_Form_78) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Cp-79 Item No.</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_cp_Form_79"
                                                                                                                    value={mcoPart2Formik.values.iv_cp_Form_79}
                                                                                                                    type='text'
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_cp_Form_79 && mcoPart2Formik.touched.iv_cp_Form_79 ? (mcoPart2Formik.errors.iv_cp_Form_79) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Ca-21 Item No.</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_ca21"
                                                                                                                    value={mcoPart2Formik.values.iv_ca21}
                                                                                                                    type='text'
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_ca21 && mcoPart2Formik.touched.iv_ca21 ? (mcoPart2Formik.errors.iv_ca21) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Ca-22 Item No.</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_ca22"
                                                                                                                    value={mcoPart2Formik.values.iv_ca22}
                                                                                                                    type='text'
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_ca22 && mcoPart2Formik.touched.iv_ca22 ? (mcoPart2Formik.errors.iv_ca22) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Name</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_meter_Changed_By"
                                                                                                                    value={mcoPart2Formik.values.iv_meter_Changed_By}
                                                                                                                    type='text'
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_meter_Changed_By && mcoPart2Formik.touched.iv_meter_Changed_By ? (mcoPart2Formik.errors.iv_meter_Changed_By) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Designation</Typography>
                                                                                                                <TextField
                                                                                                                    name="iv_meter_Changed_Designation"
                                                                                                                    value={mcoPart2Formik.values.iv_meter_Changed_Designation}
                                                                                                                    type='text'
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    className='fieldCoverageMarla'
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_meter_Changed_Designation && mcoPart2Formik.touched.iv_meter_Changed_Designation ? (mcoPart2Formik.errors.iv_meter_Changed_Designation) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                            <Grid item lg={2}>
                                                                                                                <Typography className='fieldLabel' >Installation Date</Typography>
                                                                                                                <input
                                                                                                                    name="iv_meter_Changed_Date"
                                                                                                                    value={mcoPart2Formik.values.iv_meter_Changed_Date}
                                                                                                                    fullWidth
                                                                                                                    disabled={mcoDetails.complianceFlag && CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance')}
                                                                                                                    onChange={mcoPart2Formik.handleChange}
                                                                                                                    onBlur={mcoPart2Formik.handleBlur}
                                                                                                                    type='date'
                                                                                                                    className='fieldReferenceNo'
                                                                                                                    style={{ width: '100%', height: '30px', borderWidth: '1px', borderRadius: '3px', borderColor: 'lightgrey' }}
                                                                                                                    min={mcoPart2Formik.values.iv_store_requisition_date}
                                                                                                                    max={new Date().toISOString().split('T')[0]}
                                                                                                                />
                                                                                                                <p className='form-error'>
                                                                                                                    {mcoPart2Formik.errors.iv_meter_Changed_Date && mcoPart2Formik.touched.iv_meter_Changed_Date ? (mcoPart2Formik.errors.iv_meter_Changed_Date) : null}
                                                                                                                </p>
                                                                                                            </Grid>
                                                                                                        </Grid>
                                                                                                    </Grid>
                                                                                                </> : null
                                                                                        }
                                                                                    </> :
                                                                                    dialogRowData.applicationProgressId === 6 && dialogRowData.objectionStatus === 1 ?
                                                                                        <>
                                                                                            <h3 className='step-title'>Meter Installation Objection</h3>
                                                                                            <p className='group-description'>Unable to get details of the demand notice payment. Please contact the relevant field operations officer! </p>
                                                                                        </> : null
                                    }
                                </div>
                                <div className='actions'>
                                    {dialogRowData.applicationProgressId === 0 ?
                                        <>
                                        </> :
                                        dialogRowData.applicationProgressId === 1 && dialogRowData.objectionStatus === 0 ?
                                            CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Document Verification') &&
                                                dialogRowData.applicationProgressId === 1 &&
                                                dialogRowData.objectionStatus !== 1 &&
                                                (
                                                    dialogRowData.copyOfApplicantCNICFlag !== 1 ||
                                                    dialogRowData.applicantLastPaidBillFlag !== 1
                                                )
                                                ?
                                                <button onClick={() => updateDocumentStatus()} className='view-button'  >Submit</button>
                                                :
                                                <>
                                                </>
                                            :
                                            dialogRowData.applicationProgressId === 1 && dialogRowData.objectionStatus === 1 ?
                                                <>

                                                </> :
                                                dialogRowData.applicationProgressId === 2 && dialogRowData.objectionStatus === 0 ?
                                                    CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Due Amount Verification') ?
                                                        <>
                                                            <button onClick={showArrearsEntryPopup} className='view-button' style={{ marginLeft: '2%' }}>Check Arrears</button>
                                                            <button onClick={() => callChangeProgressIdAPI(3, 'Arears Verify', 'Arears Verify')} className='view-button'>Arrears Verified</button>
                                                        </>
                                                        :
                                                        <>
                                                        </>
                                                    :
                                                    dialogRowData.applicationProgressId === 2 && dialogRowData.objectionStatus === 1 ?
                                                        <>
                                                            <h3 className='step-title'>Due Amount Objection</h3>
                                                            {
                                                                CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Due Amount Verification') ?
                                                                    <p className='group-description'>The reference number has pending unpaid dues. In case the consumer has paid the dues, remove objection by clicking below button.</p> :
                                                                    <p className='group-description'>The reference number has pending unpaid dues. </p>
                                                            }
                                                        </> :
                                                        dialogRowData.applicationProgressId === 3 && dialogRowData.objectionStatus === 0 ?
                                                            <>
                                                                {
                                                                    (CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Owner Consent') ||
                                                                        CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Owner Consent')) &&
                                                                    <button onClick={fieldFormik.handleSubmit} className='view-button' >
                                                                        {
                                                                            consentDetails.consumerConsentFillFlag === null ?
                                                                                'Submit' :
                                                                                consentDetails.consumerConsentFillFlag === 1 ?
                                                                                    'Approve' : 'Submit'
                                                                        }
                                                                    </button>
                                                                }
                                                            </> :
                                                            dialogRowData.applicationProgressId === 3 && dialogRowData.objectionStatus === 1 ?
                                                                <>

                                                                </> :
                                                                dialogRowData.applicationProgressId === 4 && dialogRowData.objectionStatus === 0 ?
                                                                    (CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Owner Consent', 'Filled Consent Approval') ||
                                                                        CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Owner Consent', 'Filled Consent Approval')) &&
                                                                    <button onClick={fieldFormik.handleSubmit} className='view-button'>
                                                                        {
                                                                            consentDetails ?
                                                                                consentDetails.consumerConsentFillFlag === null ?
                                                                                    'Submit' :
                                                                                    consentDetails.consumerConsentFillFlag == 1 ?
                                                                                        'Approve' : 'Submit' : 'Submit'
                                                                        }
                                                                    </button>
                                                                    :
                                                                    dialogRowData.applicationProgressId === 4 && dialogRowData.objectionStatus === 1 ?
                                                                        <>
                                                                        </> :
                                                                        dialogRowData.applicationProgressId === 5 && dialogRowData.objectionStatus === 0 ?
                                                                            CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'MCO Issuance') &&
                                                                            <div>
                                                                                <button onClick={mcoPart1Formik.handleSubmit} type="submit" className='view-button' disabled={mcoDetails.mcoP1FilledFlag === null} style={{ marginLeft: '10px' }}>Approve</button>
                                                                                <button onClick={mcoPart1Formik.handleSubmit} type="submit" className='view-button' disabled={mcoDetails.mcoP1FilledFlag === 1}>Submit</button>
                                                                            </div>
                                                                            :
                                                                            dialogRowData.applicationProgressId === 5 && dialogRowData.objectionStatus === 1 ?
                                                                                <>
                                                                                </> :
                                                                                dialogRowData.applicationProgressId === 6 && dialogRowData.objectionStatus === 0 ?
                                                                                    CheckPermissions('General Services', 'Opt for Smart Meter', 'Workflow Permissions', 'Meter Installation') &&
                                                                                    <>
                                                                                        <button onClick={mcoPart2Formik.handleSubmit} type="submit" className='view-button' disabled={mcoDetails.complianceFlag === null} style={{ marginLeft: '10px' }}>Approve</button>
                                                                                        <button onClick={mcoPart2Formik.handleSubmit} type="submit" className='view-button' disabled={mcoDetails.complianceFlag === 1}>Submit</button>
                                                                                    </>
                                                                                    :
                                                                                    dialogRowData.applicationProgressId === 6 && dialogRowData.objectionStatus === 1 ?
                                                                                        <>
                                                                                            <h3 className='step-title'>Meter Installation Objection</h3>
                                                                                            <p className='group-description'>Unable to get details of the demand notice payment. Please contact the relevant field operations officer! </p>
                                                                                        </> : null
                                    }
                                </div>

                            </Grid>
                        </Grid >
                    </DialogContentText >
                </DialogContent>

            </Dialog >

            {/* Document reverification Alert */}
            < Dialog
                open={docVerifyAlert}
                onClose={hideDocVerifyAlert}
                fullWidth={true}
                maxWidth={'sm'}
                className='' >
                <DialogTitle>
                    Alert!
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to check again the documents of application id: {dialogRowData.applicationId}?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => callChangeObjectionStatus(0)}>Confirm</Button>
                    <Button onClick={hideDocVerifyAlert}>Cancel</Button>
                </DialogActions>
            </Dialog >

            {/* Arrears Verification Alert Box */}
            < Dialog
                open={arrearsVerifyPopUpOpen}
                onClose={hideArrearsVerifyAlert}
                fullWidth={true}
                maxWidth={'sm'}
                className='' >
                <DialogTitle>
                    Alert!
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure to verify the arears?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => callChangeProgressIdAPI(3, "Arrears Verified", "Arrears Verified")}>Confirm</Button>
                    <Button onClick={hideArrearsVerifyAlert}>Cancel</Button>
                </DialogActions>
            </Dialog >

            {/* Arrears Entry Dialog */}
            < Dialog
                open={arrearsEntryPopUpOpen}
                onClose={hideArrearsEntryAlert}
                fullWidth={true}
                maxWidth={'sm'}
                className='' >
                <DialogTitle>
                    Arrear Details
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <p>Applied reference number:</p>
                        <TextField
                            required
                            type='text'
                            disabled
                            name="iv_property_reference_no"
                            value={arearsFormik.values.iv_property_reference_no}
                            inputProps={{ maxLength: 14 }}
                            onChange={arearsFormik.handleChange}
                            onBlur={arearsFormik.handleBlur}
                            id="iv_property_reference_no"
                            className='arearsReferenceNumber'
                        />
                        <Box className="form-error">
                            {arearsFormik.errors.iv_property_reference_no && arearsFormik.touched.iv_property_reference_no ? (arearsFormik.errors.iv_property_reference_no) : null}
                        </Box>
                        {
                            arearsFormik.values.iv_property_reference_no.length === 14 ?
                                arrearsDetails.arrearsAmount ?
                                    <Grid container spacing={2}>
                                        <Grid item lg={12}>
                                            <hr style={{ marginTop: '2%', marginBottom: '1%' }} />
                                        </Grid>
                                        <Grid item lg={4}>
                                            <Typography sx={{ fontWeight: 'bold' }}>Arrear Amount</Typography>
                                            <Typography >{arrearsDetails.arrearsAmount}</Typography>
                                        </Grid>
                                        <Grid item lg={4}>
                                            <Typography sx={{ fontWeight: 'bold' }}>Consumer Name</Typography>
                                            <Typography >{arrearsDetails.consumerName}</Typography>
                                        </Grid>
                                        <Grid item lg={4}>
                                            <Typography sx={{ fontWeight: 'bold' }}>Consumer Phone No.</Typography>
                                            <Typography >{arrearsDetails.consumerNo}</Typography>
                                        </Grid>
                                        <Grid item lg={12}>
                                            <Typography sx={{ fontWeight: 'bold' }}  >Consumer Address</Typography>
                                            <Typography >{arrearsDetails.consumerAddress}</Typography>
                                        </Grid>
                                        <Grid item lg={12}>
                                        </Grid>
                                    </Grid>
                                    :
                                    <h4>{noArrears}</h4> :
                                null
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {
                        noArrears === "No arrears exist for entered reference number." ?
                            <Button onClick={() => {
                                callChangeProgressIdAPI(3, 'Due Amount Verified', 'Due Amount Verified')
                                hideArrearsEntryAlert()
                            }}>No Arrears Verified</Button> : null
                    }
                    {
                        arrearsDetails.arrearsAmount !== '' ?
                            <Button onClick={() => {
                                callChangeObjectionStatus(1)
                                hideArrearsEntryAlert()
                                setOpen(false)
                            }} >Submit Arrears Objection</Button> : null
                    }
                    <Button onClick={hideArrearsEntryAlert} >Cancel</Button>
                </DialogActions>
            </Dialog >

            {/* Objection Dialog */}
            < Dialog
                open={objectionPopUpOpen}
                onClose={hideObjectionPopup}
                fullWidth={true}
                maxWidth={'md'}
                className='objectionDialog'
                ref={formik.resetForm}
            >
                <DialogTitle className="objection-dialog-title" >
                    <Grid container className='objectionheadercontainer'>
                        <Grid item lg={11} className='applicationTitleGrid'>
                            <Typography className="applicationTitleText">Objections</Typography>
                        </Grid>
                        <Grid item lg={1} className="closeIcon">
                            <CloseIcon id="clearPopup" onClick={hideObjectionPopup} />
                        </Grid>
                    </Grid>
                    <hr />
                </DialogTitle>
                <DialogContent className='objection-dialog-content'>
                    <DialogContentText className='objection-dialog-content-text'>
                        <Select
                            sx={{ width: '100%' }}
                            value={formik.values.iv_objection_Type}
                            onChange={ObjectionType}
                            onBlur={formik.handleBlur}
                            displayEmpty
                            className='objectionDropdownList'
                            name="iv_objection_Type"
                            id="iv_objection_Type"
                        >
                            <MenuItem value=''>Select Objection</MenuItem>
                            {
                                dialogRowData.applicationProgressId === 3 ?
                                    fieldObjections.map(option => <MenuItem key={option} value={option}>{option}</MenuItem>) : null
                            }
                        </Select>
                        <Box className='from-Error'>
                            {formik.errors.iv_objection_Type && formik.touched.iv_objection_Type ? (formik.errors.iv_objection_Type) : null}
                        </Box>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="objection-dialog-action">
                    <button onClick={formik.handleSubmit} className='submit-button'>Submit</button>
                </DialogActions>
            </Dialog >

            {/* Rejection Removal Alert */}
            < Dialog
                open={rejectionRemovalAlert}
                onClose={hideRejectionRemovalAlert}
                fullWidth={true}
                maxWidth={'sm'}
                className='' >
                <DialogTitle>
                    Alert!
                </DialogTitle>
                <DialogContent>
                    {
                        dialogRowData.applicationProgressId === 1 ?
                            <DialogContentText>
                                Are you ready to check again the documents for application id: {dialogRowData.applicationId}?
                            </DialogContentText> :
                            dialogRowData.applicationProgressId === 2 ?
                                <DialogContentText>
                                    Are you sure you want to remove the arrears objection for application id: {dialogRowData.applicationId}?
                                </DialogContentText> :
                                dialogRowData.applicationProgressId === 3 ?
                                    <DialogContentText>
                                        Are you sure you want to remove the field survey rejection for application id: {dialogRowData.applicationId}?
                                    </DialogContentText> :
                                    null
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => callChangeObjectionStatus(0)}>Confirm</Button>
                    <Button onClick={hideRejectionRemovalAlert}>Cancel</Button>
                </DialogActions>
            </Dialog >

            {/* DN Payment Verification Alert */}
            < Dialog
                open={dnPaymentVerifyAlert}
                onClose={hideDnPaymentVerifyAlert}
                fullWidth={true}
                maxWidth={'sm'}
                className='' >
                <DialogTitle>
                    Alert!
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography className='fieldLabel' >Are you surely want to verify the demand notice payment?</Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={fieldFormik.handleSubmit}>Submit</Button>
                    <Button onClick={hideDnPaymentVerifyAlert}>Cancel</Button>
                </DialogActions>
            </Dialog >

            {/* Toast Container */}
            < ToastContainer />

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >

        </>
    )
}

export default OptForSmartMeterTable;